import {
	title
} from 'echarts/lib/theme/dark';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const zh = {
	common: {
		setbtn: '已设置',
		link: '友情链接',
		more: '更多信息',
		website: '官网',
		global: '全球',
		goods: '商品',
		service: '服务',
		mallExchange1: '直联商家',
		mallExchange2: '链商平台',
	},
	commonTime: {
		minute1: '1分钟',
		minute5: '5分钟',
		minute15: '15分钟',
		minute30: '30分钟',
		hour1: '1小时',
		hour2: '2小时',
		hour4: '4小时',
		day1: '1天',
		week1: '1周',
		month1: '1个月',
	},
	tipsVal: {
		copyerror: '复制失败！',
		copySucess: '复制成功！',
		noDataTips: '暂无数据哦~',
		noBankCardTips: '还未添加银行卡信息哦~',
		inputPlaceholder: '请输入内容',
		inputPlaceholder1: '请输入',
		networkType: '网络类型',
		phone: '手机',
		logoutTips: '此操作将退出, 是否继续?',
		setChoiceAddress: '设置提币地址',
		userAuthenticate: '未进行身份认证'
	},
	verifyUser: {
		title: "身份认证",
		country: "居住地",
		name: "名",
		familyName: "姓",
		idcardNo: "证件号码",
		upload: "上传",
		reminder: "注意",
		reminderValue: "· 确保您的姓名和证件号码在照片上清晰可见",
		tips: {
			type: "PEG or PNG格式，",
			size: "不超过2MB",
			idcardImg: "请上传证件照片",
			idcardFrontImgurl: "以PNG或JPEG格式上传身份证件首页的照片",
			idcardBackImgurl: "以PNG或JPEG格式上传身份证背面",
		}
	},
	vip: {
		register: '注册用户',
		member: '会员用户',
		copartner: '合伙人',
		diamond: '钻石合伙人'
	},
	news: {
		title: "新闻活动与公告",
		titleInfo: "聚焦行业深度与前沿，深度解析趋势和机遇",
		tabVal1: '系统通知',
		tabVal2: '平台公告',
		tabVal3: '新闻活动',
		tabVal4: "研究报告",
		moreTips: '更多公告',
		noDataTips: '暂无内容哦~'
	},
	buy_box: {
		buy: '买入',
		buy_price: '买价',
		sell: '卖出',
		sell_price: '卖价',
		use: '可用',
		amount: '数量',
		money: '金额',
		loading: '登录',
		add_success: '委托成功',
		trans_confirm: '交易确认',
		buy_confirm: '确认买入',
		sell_confirm: '确认卖出',
		trans_amount: '交易额',
		trans_password_placeholder: '请输入交易密码',
		confirm: '确认',
		cancel: '取消',
		verification: '验证',
		withdraw: '提现',
		chain_withdraw: '链上提现',
		input_error: '金额或者数量必须大于0'
	},
	nav: {
		home: '首页',
		mall: '商城',
		ctc: '二手市场',
		otc: '法币交易',
		faq: '常见问题',
		partner: '会员计划',
		financial: 'RWA理财',
		burst: '爆块奖励',
		apply: '上币申请',
		download: 'APP下载',
		order: '订单',
		assets: '资产',
		login: '登录/注册',
		mine: '我的',
		ann_more: '查看更多>>',
		ann_drop: {
			system: '系统通知',
			ann: '平台公告',
			news: '行业新闻',
			login: '登录后可查看',
		},
		user_drop: {
			partner_register: '注册用户',
			partner_member: '会员用户',
			partner_partner: '合伙人',
			partner_diamond: '钻石合伙人',
			center: '个人中心',
			address: '提币地址管理',
			order: '订单管理',
			receipt: '收款设置',
			api: 'API管理',
			out: '退出'
		}
	},
	mall: {
		title: "商城",
		status1: "进行中",
		status2: "未开始",
		status3: "认购结束",
		status4: "认购N/A",
		assetType: "资产类别",
		assetTime: "发行时间",
		assetPrice: "发行价格",
		issuanceTotal: "发行总额",
		outstandingUnits: "流通总量",
		delivery: "配送地区",
		payPrice: "最小购买",
		typeGoods: "商品",
		typeService: "服务",
		mallUrl: "链商平台",
		showDetail: "点击查看",
		subscription_price: "认购价格",
		share_quantity: "每份数量",
		total_supply: "发售总量份数",
		total_value: "发售总价值",
		shares_unit: "份",
		issue_unit: "份",
		pieces_per_share: "个/份",
		pre_sale: "抢先购",
		open_sale: "开放购",
		view_details: "查看详情",
		starts: "开始",
		ends: "结束",
		detail: {
			title: '商品详情',
			type: 'BNB智能链',
			typeInfo: '由MEIMEI INTERNATIONAL HOLDINGS LIMITED发行',
			btn1: '进入二手市场',
			btn2: '商链平台',
			tab1: '详情',
			tab2: '文档',

			goodsType: "产品类型",
			mallExchange: "兑　　换",
			debutStartTime: "首发开始",
			debutEndTime: "首发结束",
			goodsName: "上架名称",
			symbol: "简称",
			network: "网络",
			protocol: "协议",
			contract: "合约地址",
			issuer: "发行方",
			publishAmount: "发行总量",
			tradeAmount: "交易总量",
			decimal: "精度",
			totalValue: "发行总额",
			firstValue: "首单发行",
			minBuyAmount: "最小购买量",
			maxBuyAmount: "最大购买量",
			showWhitePage: "查看白皮书",

			chainInfo: "链上信息",
			view: "查看",
			hide: "隐藏",

			noData: "暂无商城产品哦~",

			coinInfo1: '香港100强上市企业联盟有限公司',
			coinInfo2: 'RWA Group Limited',
			coinInfo3: 'Meimei International Holdings Limited',
		}
	},
	mallDetail: {
		title: "代币详情",
		issue_price: "发行价格",
		issue_amount: "发行数量",
		min_buy_shares: "最小购买份数",
		max_buy_shares: "最大购买份数",
		subscription_period: "认购期",
		distribution_start: "分发开始",
		distribution_end: "分发结束",
		start_trading: "开始交易",
		purchase_info: "认购信息",
		max_subscription: "最大可认购",
		purchase_price: "认购价格",
		subscribed: "已认购",
		share: "份",
		whitelist_info: "白名单信息",
		whitelist_status: "白名单状态",
		whitelist_max: "白名单最大购买",
		remaining_buy: "剩余可购",
		enabled: "已开启",
		disabled: "未开启",
		chain_info: "链上信息",
		network: "网络",
		blockchain: "区块链",
		protocol: "协议",
		contract_address: "合约地址",
		whitepaper: "白皮书",
		explorer: "浏览器",
		view_whitepaper: "查看白皮书",
		copy: "复制",
		copy_success: "复制成功",
		copy_fail: "复制失败",
		faq: "常见问题",
		buy_now: "立即购买",
		ended: "已结束",
		waiting: "等待中",
		will_open: "即将开始",
		please_login: "请登录",
		non_whitelist: "未在白名单",
		exceed_max_buy_shares: "超出最大购买份数",
		started: "已开始",
		day: "天",
		hour: "时",
		minute: "分",
		second: "秒",
		sold_progress: "发售进度",
		sold: "已售",
		remaining: "剩余",
	},
	question: {
		title: "常见问题",
		info1: 'RWA.LTD为用户提供了一个怎样的平台？',
		infoText1: 'RWA.LTD为用户提供了一个怎样的平台？',
		info2: '注册平台用户的要求和限制',
		infoText2: '注册平台用户的要求和限制',
		info3: '注册平台用户的要求和限制',
		infoText3: '本平台对于已完成KYC认证的用户推出邀请奖励活动，若受邀用户通过邀请链接或邀请码在本平台注册账户并完成KYC认证，发出邀请的用户未来可以获得受邀用户买入交易的手续费返佣(比例为一级15%，二级5%)。在KYC认证通过后，您可以在“个人中心-账号管理-查看我的邀请”中获得邀请码，新用户也可以通过点击邀请链接与您绑定邀请关系。本平台保留随时更改前述活动内容或者取消前述活动的权利，此类“更新”或者“取消”可能并不会及时反映在此。',
		info4: '为何不能成功注册或登录？',
		infoText4: '为何不能成功注册或登录？',
		info5: '如何购买平台创世代币RWA Coin(“RWA”)?',
		infoText5: '如何购买平台创世代币RWA Coin(“RWA”)?',
	},
	home: {
		header: {
			title1: '链商平台 重磅来袭',
			title2: '代币机制和商品经济的创新性结合，为您带来全新体验',
			title: 'WTZ交易所',
			con: '百万富翁合伙人计划',
			rules: '查看活动详情>>',
			member_num: '会员人数',
			register_num: '注册用户',
			register_btn: '点击注册',
		},
		table: {
			header: {
				userCollect: '自选',
				search: '搜索交易币种'
			},
			row: {
				rwatype: 'RWA代币',
				type: '交易对',
				price: '二手指导价',
				high: '24H最高价',
				low: '24H最低价',
				rang: '24H涨跌幅',
				volume: '24H交易量',
				amount: '24H成交额',
				operation: '操作',
				buy: '买入',
				sell: '卖出'
			},
			more: '查看更多'
		},
		introduction: {
			h1: 'WTZ交易所，全球最大的会员制交易所',
			h3: '为全球用户提供安全、可信赖的数字资产交易及资产管理服务，与全球会员共享平台红利',
			part1: {
				title: '独创会员制',
				con: '采用社区共建、让利会员的方式，打造全球最大的会员制交易所'
			},
			part2: {
				title: '系统稳定可靠',
				con: '多层多集群系统架构、高性能撮合引擎技术、银行级用户数据加密、动态身份验证等，保障交易安全'
			},
			part3: {
				title: '资金安全有保障',
				con: '多重签名、离线签名、冷热钱包叠合等先进的技术，为客户提供安全、可信赖的数字资交易服务'
			},
			title: {
				merchant1: '卖家',
				merchant2: '买家',
				text1: '创新性改革商品经济',
				text2: 'RWA.LTD通过代币机制和商品市场的创新结合，为买家和卖家各⾃提供WEB3纪元下的交易渠道和交易模式。',
				text3: '定制化非金融性品牌代币方案',
				text4: '品牌方为何前来？前置营收现金流 + 可预见性轻量运营 + 高效管理的品牌粉丝流量社区',
				text5: '确享无门槛代币零售交易',
				text6: '消费者为何前来？7×24小时不间断链上交易 + 随时脱粉品牌的理由 + 更具吸引力的预售价格 + 随时转让的“新鲜”囤货',
				text7: '将商品经济改写为链商经济',
				text8: '通过包罗万象却质规上乘的非金融性资产选品，面向每一个人的零售用户画像设计，以及突破性的交易收藏一体化集成，RWA.LTD 立足实体经济，以用户权益为第一出发点，力求为所有人提供一个值得信赖的、有价值依托的并且能切实运用区块链技术红利的代币交易平台。',
				text9: '新闻活动与公告',
				text10: '更多公告',
			}
		},
		download: {
			title: '随时随地，交易更轻松',
			con: 'WTZ交易所为用户提供交易终端，支持IOS、Android和Web，并为专业交易者提供毫秒级延迟的API服务 语言涵盖中文、英文等，致力于为客户提供一流的投资体验',
			ios: 'IOS下载',
			android: 'Android下载'
		},
		register: {
			title: '注册WTZ账号，开启数字货币之旅',
			placeholder: '请输入手机号或邮箱',
			btn: '立即注册'
		},
		footer: {
			about: '关于我们',
			legal: '平台条款',
			terms: '用户协议',
			buyProtocol: '购买协议',
			questions: '常见问题',
			ecosystem: '生态系统',
			rwaApp: 'RWA应用',
			emailAddress: '邮箱地址',
			companyaddress: '公司地址',
			production: '产品',
			question: '问题反馈',
			rate: '费率标准',
			partner: '成为合伙人',
			apply: '上币申请',
			api: 'API接入',
			app: 'APP下载',
			ann_help: '公告帮助',
			off_ann: '官方公告',
			help: '帮助中心',
			agreements: '用户协议',
			privacy: '隐私政策',
			contact: '联系我们',
			business: '商务合作',
			service: '客服',
			institutional: '机构合作'
		},
		v2: {
			hero: {
				tag: 'RWA.LTD · 消费级 RWA 基础设施',
				title1: '连接现实世界资产',
				title2: '实现链上流通，创造平台价值',
				title3: '',
				desc: 'RWA.LTD 将现实世界的商品、服务与商业权益，以透明数字化的形式接入链上，通过链上流通与现实兑付，连接实体商品、服务及商业权益。',
				btn1: '探索消费级 RWA',
				btn2: '观看影片',
				tag1: '产品与品牌',
				tag2: '商业',
				tag3: '履约'
			},
			banners: {
				card1: 'RWA.LTD 新版发布！会员尊享限时多重福利',
				card2: 'GCT，全球首个链商咖啡 RWA，现已在 rwa.ltd 上线',
				card3: '全新升级！RWA.LTD 官方新网站正式上线',
				card4: '专注区块链代币商城，尽享无忧购物',
				btn: '点击查看'
			},
			quotes: {
				title1: '热门市场行情',
				title2: '二手市场',
				desc: '掌握最新加密货币价格波动，把握每一次交易机会。RWA 提供行业领先的流动性和深度。',
				totalAssets: '总资产',
				todayPnl: '今日盈亏',
				viewManage: '查看和管理资产',
				partner: '合伙人计划',
				viewAll: '查看全部'
			},
			news: {
				title1: '新闻、活动及',
				title2: '公告',
				viewAll: '查看全部',
				explore: '查看'
			},
			consumer: {
				eyebrow: 'CONSUMER RWA MODEL',
				title1: '从实体商品',
				title2: '及服务升级为可管理的数字权益',
				item1: {
					title: '真实商业价值',
					desc: '商品、服务、会员权益与福利，都基于真实商业场景。'
				},
				item2: {
					title: '数字化呈现',
					desc: '权益通过数字化形式呈现，并具备清晰规则与可验证的项目材料。'
				},
				item3: {
					title: '流通与兑付',
					desc: '建立闭环流通路径，并回到真实产品和服务的兑现链路。'
				}
			},
			solutions: {
				eyebrow: '解决方案',
				title1: '从想法',
				title2: '到发行、流通与兑付',
				link: '探索全生命周期',
				items: {
					commonExplore: '查看',
					issuance: {
						title: '发行与兑付设计',
						desc: '代币规则、权益结构与兑付逻辑'
					},
					materials: {
						title: '核心项目材料',
						desc: '白皮书、项目指引与关键文档'
					},
					deployment: {
						title: '区块链部署',
						desc: '安全、可扩展地与项目模型保持一致部署'
					},
					launch: {
						title: '上线与品牌传播',
						desc: '面向市场的叙事与项目沟通'
					},
					circulation: {
						title: '平台流通',
						desc: '连接平台、用户与商业渠道的协同流通'
					},
					redemption: {
						title: '兑付与履约',
						desc: '真实世界交付、服务接入及权益履约'
					}
				}
			},
			projects: {
				eyebrow: '精选生态项目',
				title1: '真实项目，',
				title2: '真实商业价值',
				viewAll: '查看全部',
				end: '结束',
				explore: '查看'
			},
			discuss: {
				title1: '构建下一代真实世界',
				title2: '数字商业',
				button: '洽谈您的项目'
			},
			film: {
				p1: '动画平台影片',
				title1: 'RWA.LTD 平台',
				title2: '驱动真实价值上链',
				desc: '了解现实世界资产如何从定义和发行，逐步走向流通与履约。',
				btn: '观看影片'
			},
			infrastructure: {
				eyebrow: '关于 RWA.LTD',
				title: '面向未来的基础设施',
				title2: '服务现实世界数字商业',
				desc1: 'RWA.LTD 是一个消费级 RWA 平台，帮助品牌、项目方和商户发行、流通和兑付由真实资产与服务背书的数字商业权利。',
				desc2: '我们将项目结构、数字化部署、传播、平台流通和履约连接在同一生命周期内，为真实世界的商业价值提供一体化链上承载。',
				button: '了解我们的模式'
			}
		}
	},
	trade_ctc: {
		trans_start: '后开启交易',
		header: {
			price: '二手指导价',
			change: '24小时涨跌幅',
			high: '24小时最高',
			low: '24小时最低',
			volume: '24小时成交量',
			search: '搜索币种',
			self: '自选'
		},
		buyAndSell: {
			price: '价格',
			volume: '数量',
			money: '金额',
			limit_delegation: '限价委托',
			current_delegation: '当前委托',
			history_delegation: '历史委托'
		},
		delegationTable: {
			time: '委托时间',
			pay_type: '交易类型',
			buy: '买入',
			sell: '卖出',
			amount: '委托数量',
			beenDone: '已成交',
			price: '委托价格',
			averagePrice: '成交均价',
			money: '成交总额',
			status: '状态',
			trading: '交易中',
			un_trade: '未交易',
			canceled: '已取消',
			part_completed: '部分完成',
			canceling: '撤销中',
			completed: '已完成',
			operation: '操作',
			cancel: '撤销',
			cancel_success: '撤销成功',
			deleteRecord: '删除',
			delete_success: '删除成功'
		},
		deal: {
			title: '最新成交',
			amount: '数量',
			price: '价格',
			time: '时间'
		},
		search: {
			placeholder: '搜索币种',
			self: '自选',
			coin_type: 'RWA币种',
			price: '最新价',
			range: '涨跌幅'
		}
	},
	login: {
		title1: '欢迎登录',
		title: '欢迎登录WTZ',
		pwd: '密码',
		tips: '还不是注册用户？',
		phone_login: '手机登录',
		email: '邮箱',
		newemail: '新邮箱地址',
		newemailcode: '新邮箱验证码',
		email_login: '邮箱登录',
		input_phone1: '手机号',
		input_phone: '手机号（仅支持中国大陆地区）',
		input_email: '请输入邮箱',
		input_email1: '请输入有效的邮箱',
		input_password: '请输入密码',
		login: '登录',
		forget: '忘记密码？',
		no_account: '还没有账号？',
		register_now: '立即注册',
		verify: '验&nbsp;&nbsp;&nbsp;&nbsp;证',
		close: '关&nbsp;&nbsp;&nbsp;&nbsp;闭',
		code_input: '请输入验证码'
	},
	register: {
		title1: '欢迎注册',
		title: '欢迎注册WTZ',
		phone: '手机号',
		register_phone: '手机注册',
		register_email: '邮箱注册',
		input_phone: '请输入手机号',
		input_email: '请输入邮箱',
		code: '验证码',
		get_code: '获取验证码',
		input_code: '请输入验证码',
		input_mes_code: '请输入短信验证码',
		input_email_code: '请输入邮箱验证码',
		input_password: '请设置登录密码，8～32位数字、字母或符号',
		confirm_password: '请再次输入密码',
		invite_code: '邀请码',
		invite_code_tip: '请输入邀请码',
		register: '注册',
		agree1: '我已阅读并同意用户协议',
		agree: '我已阅读并同意',
		policy: '《用户协议及隐私政策》'
	},
	alert: {
		register_success: '注册成功'
	},
	validate: {
		account_require: '账号不能为空',
		password_require: '密码不能为空',
		code_require: '验证码不能为空',
		mes_code_require: '短信验证码不能为空',
		email_code_require: '邮箱验证码不能为空',
		google_code_require: '谷歌验证码不能为空',
		password_formatter_error: '密码格式错误',
		password_formatter_tip: '密码为8到32个数字与字母的组合',
		password_confirm_again: '请再次输入密码',
		password_confirm_error: '密码两次输入不一致',
		phone_require: '请输入手机号码',
		email_require: '请输入邮箱',
		email_formatter_error: '邮箱格式错误',
		country_require: '请选择居住地',
		name_require: '姓不能为空',
		familyName_require: '名不能为空',
		id_require: '证件号不能为空',
		depositBank_require: '开户银行不能为空',
		bankNum_require: '银行卡号不能为空',
		bankNum_confirm_error: '两次输入的卡号不一致',
		trans_password_require: '交易密码不能为空',
		trans_password_formatter_tip: '交易密码为6～32位数字或字母',
		alipay_account_require: '支付宝账号不能为空',
		wechat_account_require: '微信账号不能为空',
		geet_require: '请完成验证',
		agree_require: '请先阅读用户协议',
		address_require: '地址不能为空',
		amount_require: '数量不能为空',
		amount_min: '不能小于',
		amount_over_0: '请输入大于0的数字',
		type_number: '必须为数字',
		incomplete_information: '信息未完善',
		coin_type_error: '币种填写有误',
		alias_require: '地址别名不能为空',
		invite_code_require: '邀请码不能为空',
		description_require: '备注不能为空',
		roles_require: '请选择API权限',
		qr_code_require: '请上传二维码',
		upload_error: '上传图片失败!',
		upload_type: '上传图片只能是 JPG、JPEG 或者 PNG 格式!',
		upload_size: '上传头像图片大小不能超过 2MB!',
		upload_compress: '图片较大，正在压缩中...',
		input_err_tips: "请输入正确的内容~"
	},
	user_center: {
		tip: '提示',
		tip_val2: '使用于法币合规出入金，请务必使用本人账户并确保信息正确可靠！',
		my_share: '我的邀请',
		my_invite_code: '我的邀请码',
		securitySettings: '安全设置',
		login_history: '登录历史',
		login_safety_history: '安全设置历史',
		login_text: '账户登录',
		login_out_text: '退出账号',
		copy_share_url: '复制邀请链接',
		share_tips_val: '每天08:00:00 (GMT+0800) 将返还前24小时邀请邀请奖励，直接发放到币币账户，请注意查收。',
		accountManagement: '账号管理',
		accountSettings: '账号设置',
		apiManagement: 'API管理',
		paySettings: '收款设置',
		orderManagement: '订单管理',
		saleOrder: '发售订单',
		marketOrder: '市场订单',
		see_user_share: '查看我的邀请',
		update_user_img: '更换头像',
		need_bind: '需要同时绑定手机号与邮箱',
		need_bind1: '需要同时绑定谷歌验证器与邮箱',
		bind_now: '现在绑定',
		need_tran_password: '需要设置交易密码',
		set_now: '现在设置',
		need_auth: '需要身份审核',
		kyc_phone: '请在手机端进行身份认证',
		i_know: '我知道了',
		cancel: '取消',
		base_info: {
			title: '基础信息'
		},
		account_setting: {
			title: '账户设置',
			add: '添加',
			manage: '管理',
			setting: '设置',
			address: {
				title: '提币地址管理',
				tip: '地址认证,安全保障',
			},
			receipt: {
				title: '收款设置',
				tip: '保障账户安全'
			},
			api: {
				title: 'API设置',
				tip: '创建API密钥'
			}
		},
		account_safe: {
			title: '账户安全',
			title_tip: '至少保留两种验证方式',
			authenticate: '认证',
			not_authenticate: '未认证',
			has_authenticate: '已认证',
			has_authenticate_lvl: '已高级认证',
			ing_authenticate: '审核中',
			fail_authenticate: '审核失败',
			fail_reason: '失败原因:',
			authenticate_again: ',是否重新认证？',
			again: '重新认证',
			close: '关闭',
			detail: '详情',
			bind: '绑定',
			setting: '设置',
			has_bind: '已绑定',
			not_bind: '未绑定',
			open: '开启',
			not_open: '未开启',
			has_open: '已开启',
			change: '更换',
			modify: '修改',
			get_back: '找回',
			identity: {
				title: '身份认证',
				tipsVal: '身份核验，为了您的权益'
			},
			login_password: {
				title: '登录密码',
				tip: '保障账户安全'
			},
			trade_password: {
				btn: '设置',
				title: '交易密码',
				tip: '保障账户安全'
			},
			phone: {
				title: '手机绑定',
				tipsVal: '用于提现，修改密码，安全设置时用于收取验证短信'
			},
			email: {
				title: '邮箱设置',
				tipsVal: '用于登录、提币、安全设置时使用'
			},
			google: {
				title: '谷歌验证',
				bind: '绑定谷歌',
				title1: '谷歌验证码',
				tipsVal: '用于提币、找回密码、修改安全设置、管理API时进行安全验证',
				tipsVal2: '请先绑定谷歌验证器'
			},
			authenticate_trade: {
				title: '交易验证',
				tip: '保障账户安全'
			},
			alert: {
				con: '安全验证关闭后，24小时无法提币和OTC交易',
				close_phone_title: '确定关闭手机验证？',
				close_email_title: '确定关闭邮箱验证？',
				close_google_title: '确定关闭谷歌验证？',
				cancel: '取&nbsp;&nbsp;&nbsp;&nbsp;消',
				confirm: '确&nbsp;&nbsp;&nbsp;&nbsp;定'
			}
		},
		table: {
			login_recently: {
				type: '类型',
				title: '最近登录',
				time: '时间',
				ways: '登录方式',
				status: '状态',
				status1: '现状',
				address: '登录所在地',
				address1: '登录地址',
				success: '登录成功',
				error: '失败',
				success1: '成功',
				fail: '登录失败'
			},
			setting_history: {
				title: '安全设置历史',
				time: '时间',
				safe_setting: '安全设置',
				address: '登录所在地'
			}
		}
	},
	phone_bind: {
		title: '绑定手机',
		success: '手机号绑定成功'
	},
	google_bind: {
		user_center: '个人中心',
		google_validate: '绑定谷歌验证器',
		google_change: '更换谷歌验证器',
		tip: '谷歌验证器是一款动态口令工具，工作原理类似短信动态验证。绑定后每30s生成一个动态验证码，验证码可用于登录、提现、修改安全设置等操作的安全验证。',
		download_title: '下载谷歌验证器APP',
		download_desc: 'iOS用户登录App Store搜索“Authenticator”下载。安卓用户登录应用商店或使用手机浏览器搜索“谷歌验证器”下载。',
		add_title: '在谷歌验证器中添加密钥并备份',
		add_desc: '打开谷歌验证器，扫描下方二维码或手动输入下述密钥添加验证令牌。',
		copy_key: '复制秘钥',
		add_tip: '密钥用于手机更换或遗失找回谷歌验证器，绑定前请务必奖下述密钥备份保存。',
		change_tip: '更换绑定谷歌验证器后，24小时内禁止提币和OTC交易',
		input_code: '输入谷歌验证器中6位验证码',
		google_code_placeholder: '请输入谷歌验证码',
		success_tip: '完成绑定',
		success_tip2: '密钥用于手机更换或遗失时找回谷歌验证器，绑定前请务必将上述密钥备份保存。',
		next: '下一步',
		bind_title: '绑定谷歌安全验证',
		change_title: '更换谷歌安全验证',
		phone_code: '短信验证码',
		email_code: '邮箱验证码',
		get_code: '获取验证码',
		code_placeholder: '请输入验证码',
		email_code_tip: '若未收到邮件，请检查邮箱垃圾箱',
		confirm: '确定',
		cancel: '取消',
		success: '谷歌验证绑定成功',
		change_success: '谷歌验证更换成功'
	},
	validation_off: {
		title_phone: '关闭手机验证',
		tip_phone: '关闭手机验证后24小时内禁止提币和OTC交易',
		title_email: '关闭邮箱验证',
		tip_email: '关闭邮箱验证后24小时内禁止提币和OTC交易',
		title_google: '关闭谷歌验证',
		tip_google: '关闭谷歌验证后24小时内禁止提币和OTC交易',
		phone: '手机号',
		email: '邮箱',
		phone_placeholder: '请输入手机号',
		phone_code: '短信验证码',
		code_placeholder: '请输入验证码',
		email_code: '邮箱验证码',
		google_code: '谷歌验证码',
		confirm: '确定',
		phone_off_success: '手机验证已关闭',
		email_off_success: '邮箱验证已关闭',
		google_off_success: '谷歌验证已关闭',
		google_lost: '谷歌验证码丢失？',
		please_click: '请点击这里'
	},
	validation_on: {
		title_phone: '开启手机验证',
		title_email: '开启邮箱验证',
		title_google: '开启谷歌验证',
		phone_open_success: '手机验证开启成功',
		email_open_success: '邮箱验证开启成功',
		google_open_success: '谷歌验证开启成功',
	},
	password_recovery: {
		title: '找回登录密码',
		title1: '重置登录密码',
		title3: '确认您的密码',
		tip3: '修改密码后24小时内禁止提币',
		tip: '修改登录密码后24小时内禁止提币',
		tip1: '至少 8 个字符并且存有数字字母',
		tip2: '已经是注册用户？',
		btn_login: '立即登录',
		account: '邮箱',
		account_placeholder: '请输入邮箱',
		mes_code: '短信验证码',
		email_code: '邮箱验证码',
		google_code: '谷歌验证码',
		getCode: '获取验证码',
		code_placeholder: '请输入验证码',
		nextStep: '下一步',
		password: '登录密码',
		update_password: '修改密码',
		old_password: '原登录密码',
		new_password: '新登录密码',
		confirm: '确认密码',
		password_placeholder: '请输入密码',
		submit: '提交',
		back: '返回',
		success: '密码重置成功'
	},
	password_modify: {
		title: '修改登录密码',
		tip: '修改登录密码后24小时内禁止提币和OTC交易',
		old_password: '当前登录密码',
		old_password_placeholder: '请输入密码',
		new_password: '请输入密码',
		new_password_placeholder: '请输入新密码',
		password_confirm: '确认新登录密码',
		password_confirm_placeholder: '请再次输入密码',
		mes_code: '短信验证码',
		email_code: '邮箱验证码',
		google_code: '谷歌验证码',
		google_placeholder: '请输入谷歌验证码',
		getCode: '获取验证码',
		code_placeholder: '请输入验证码',
		submit: '提交',
		forget: '忘记登录密码',
		success: '登录密码修改成功'
	},
	set_trade_password: {
		title: '设置交易密码',
		password_input: '请输入交易密码',
		password_formatter: '至少6位有效数字或字母',
		password_confirm: '确认密码',
		phone_num: '手机号',
		mes_code: '短信验证码',
		email_code: '邮箱验证码',
		code_placeholder: '请输入验证码',
		getCode: '获取验证码',
		submit: '提&nbsp;&nbsp;&nbsp;&nbsp;交',
		cancel: '取&nbsp;&nbsp;&nbsp;&nbsp;消',
		success: '交易密码设置成功',
		bind_phone: '请先绑定手机号',
		email_phone: '请先绑定邮箱',
		go_bind: '去绑定'
	},
	modify_trade_password: {
		title: '修改交易密码',
		password_input: '请输入交易密码',
		new_password_input: '请输入新交易密码',
		password_formatter: '至少6位有效数字或字母',
		password_confirm: '确认密码',
		mes_code: '短信验证码',
		email_code: '邮箱验证码',
		google_code: '谷歌验证码',
		code_placeholder: '请输入验证码',
		google_placeholder: '请输入谷歌验证码',
		getCode: '获取验证码',
		submit: '提&nbsp;&nbsp;&nbsp;&nbsp;交',
		cancel: '取&nbsp;&nbsp;&nbsp;&nbsp;消',
		success: '交易密码修改成功'
	},
	authentication: {
		title: '身份认证',
		country: '国籍',
		country_placeholder: '请选择居住地',
		name: '姓名',
		name_placeholder: '请输入姓名',
		IDType: '证件类型',
		IDCard: '身份证',
		passport: '护照',
		ID: '证件号码',
		idNum_placeholder: '',
		submit: '提&nbsp;&nbsp;&nbsp;&nbsp;交',
		cancel: '取&nbsp;&nbsp;&nbsp;&nbsp;消',
		tip: '· 为了您的资金安全，需验证您的身份才可进行其他操作<br>' +
			'· 认证信息一经验证不可修改，请务必如实填写<br>' +
			'· 认证后可进行提币、法币交易等操作',
		front: {
			title: '本人身份证正面照片：',
			con: '· 请确保照片的内容完整并清晰可见<br>' +
				'· 支持jpg/png/jpeg图片格式<br>' +
				'· 图片大小不能超过2M'
		},
		back: {
			title: '本人身份证背面照片：',
			con: '· 请确保照片的内容完整并清晰可见<br>' +
				'· 身份证必须在有效期内<br>' +
				'· 仅支持jpg/png/jpeg图片格式'
		},
		hand: {
			title: '本人手持证件照：',
			con: '· 请上传一张手持证件正面照和个人签字的照片<br>' +
				'· 个人签字的内容包含手写<label style="color: #F04C66">日期</label><br>' +
				'· 仅支持jpg/png/jpeg图片格式'
		},
		success: '提交成功'
	},
	trade_auth_setting: {
		title: '交易验证',
		tip: '关闭后，下单时不再需要密码验证',
		open: '始终开启',
		close: '永久关闭',
		submit: '提&nbsp;&nbsp;&nbsp;&nbsp;交',
		cancel: '取&nbsp;&nbsp;&nbsp;&nbsp;消',
		input_password: '请输入交易密码',
		success: '修改成功'
	},
	email_bind: {
		title: '绑定邮箱',
		email: '邮箱',
		email_placeholder: '请输入邮箱',
		email_code: '邮箱验证码',
		getCode: '获取验证码',
		code_placeholder: '请输入验证码',
		bind: '绑定',
		back: '返回',
		success: '邮箱绑定成功'
	},
	googleBind: {
		google_code: '谷歌验证码',
		code_placeholder: '请输入验谷歌验证码',
	},
	withdrawal_address_manage: {
		title: '提币地址管理',
		add_address: '如何添加提币地址？',
		coin_type: '币种',
		network: "网络",
		search_coin: '搜索币种',
		another_name: '地址别名',
		another_name_placeholder: '请输入地址别名',
		address: '提币地址',
		address_placeholder: '请输入或粘贴地址',
		memo_placeholder: '请输入标签',
		memo_tip: '如您被要求填写地址标签(Destination Tag)或数字ID或备注，请在此处填写；反之则不需要填写。',
		add: '添&nbsp;&nbsp;&nbsp;&nbsp;加',
		unbind: '未绑定',
		phone_code: '短信验证码',
		email_code: '邮箱验证码',
		google_code: '谷歌验证码',
		code_placeholder: '请输入验证码',
		get_code: '获取验证码',
		my_withdraw: '我的提币',
		operation: '操作',
		withdraw: '提币',
		del: '删除',
		add_success: '添加成功',
		tip: '提示',
		delete_tip: '是否确定删除',
		delete_btn: '删除',
		cancel: '取消',
		delete_success: '删除成功',
		go_bind: '去绑定'
	},
	receipt_money: {
		title: '收款设置',
		legal_tender: '法币',
		receiptType: '收款方式',
		bankcard: '银行卡',
		alipay: '支付宝',
		wechat: '微信',
		add: '添&nbsp;&nbsp;&nbsp;&nbsp;加',
		news_title: '新消息提醒<label style="color: #A0AAC1; font-size: 16px;">(我们会以邮件或短信的方式告知您OTC订单的最新进展)</label>',
		email_notice: '邮件通知',
		phone_notice: '短信通知',
		table_title: '我的收款地址<label style="color: #A0AAC1; font-size: 16px;">(同种收款方式仅可添加一个账号)</label>',
		account: '账号',
		name: '姓名',
		bank_info: '银行信息',
		operation: '操作',
		edit: '编辑',
		del: '删除',
		dialog_title: '请填写收款信息',
		deposit_bank: '开户银行',
		bank_address: '开户地址',
		optional: '选填',
		bankcard_num: '银行卡号',
		confirm_num: '确认卡号',
		input_again: '请再输入一次',
		memo: '备注信息',
		trans_password: '交易密码',
		input_trans_password: '请输入交易密码',
		submit: '确认资料',
		alipay_account: '支付宝账号',
		upload_qr: '二维码上传',
		wechat_account: '微信账号',
		add_success: '添加成功',
		save: '保存',
		edit_success: '编辑成功',
		tip: '提示',
		delete_tip: '是否确定删除',
		delete_btn: '删除',
		cancel: '取消',
		delete_success: '删除成功',
		needRealName: '需要实名认证',
		authentication: '去认证'
	},
	order_manage: {
		ctc_order: '币币订单',
		current_delegation: '当前委托',
		history_delegation: '历史委托',
		coin_type: '币种',
		all: '全部',
		all_direction: '全部方向',
		time_start: '开始时间',
		time_end: '结束时间',
		buy: '买入',
		sell: '卖出',
		search: '搜&nbsp;&nbsp;&nbsp;&nbsp;索',
		delete_order: '删除无效订单',
		time: '时间',
		symbol: '交易对',
		way: '方式',
		direction: '方向',
		limit: '限价',
		price: '价格',
		amount: '数量',
		total: '委托总额',
		dk: '消耗DK',
		status: '状态',
		had_cancel: '已撤销',
		had_complete: '已完成',
		deal_concluded: '已成交数量',
		no_deal_concluded: '未成交',
		operation: '操作',
		order_id: '订单号',
		done_price: '成交价',
		done_amount: '成交量',
		fee: '手续费',
		cancel: '撤销',
		detail: '详情',
		delete_record: '删除',
		cancel_success: '撤销成功',
		delete_success: '删除成功',
		search: '搜索'
	},
	asset: {
		overview: '总览',
		rwa_token: 'RWA代币',
		fund: '资金',
		estimated_total_assets: '预估总资产',
		today_profit_loss: '今日盈亏',
		recharge: '充值',
		withdraw: '提现',
		records: '记录',
		asset_account: '资产账户',
		asset: '资产',
		usd: 'USD',
		us_dollar: 'USD',
		hk_dollar: 'HKD',
		trade: '交易',
		no_data: '暂无数据',
		can_not_recharge: '当前币种暂不支持充值',
		can_not_withdraw: '当前币种暂不支持提现',
		loaded_all: '已加载全部',
		mall_detail: '商城详情',
		no_mall_detail: '暂无商城详情',
		available: '可用数量',
		frozen: '冻结数量',
		market_trade: '市场交易',
		no_market_data: '暂无市场数据',
		exchange_hkd_to_ht: '{coin} Coin可用{base}购买',
		exchange_record: '{coin}兑换记录>',
		go_now: '立即前往'
	},
	exchangeRecord: {
		title: '{coin}兑换记录',
		detail_title: '{coin}兑换详情',
		order_no: '交易编号',
		transfer_amount: '转账数量',
		ht_amount: '兑换数量',
		actual_transfer: '实际转账',
		actual_exchange: '实际兑换',
		rate: '适用汇率',
		recharge_time: '充值时间',
		transfer_account_info: '转账账户',
		transfer_serial: '转账流水号',
		transfer_time: '转账时间',
		review_time: '审核时间',
		airdrop_time: '空投时间',
		reject_reason: '驳回原因',
		status: '状态',
		status_completed: '已完成',
		status_pending: '待审核',
		status_rejected: '已拒绝',
		no_data: '暂无兑换记录',
		loaded_all: '已全部加载完毕~'
	},
	exchangeHKD: {
		title: '{coin}兑换',
		how_to_exchange: '如何进行HKD兑换（以HT为例）',
		step1: '第1步：HT转账',
		step2: '第2步：审核通过得HT',
		step3: '第3步：售出HT得USD',
		transfer_amount: '转账数量',
		input_amount_placeholder: '请输入充值数量，最低100 HKD',
		ht_amount: '可得{coin}数量',
		rate: '汇率',
		receipt_account: '收款账户',
		account_number: '收款账户',
		company: '开户公司',
		bank: '开户行',
		form_title: '为方便审核，请提供您的转账银行卡信息',
		transfer_account: '转账账户',
		transfer_name: '转账人姓名',
		transfer_serial: '转账流水号',
		input_placeholder: '请输入',
		tip1: '请务必确认转账数量和输入数量一致，数据不一致会造成充值失败。',
		tip2: '转账完成后，等待后台审核，一般24小时内到账。',
		tip3: '特殊情况，可联系客服，提供充值订单号咨询。',
		tip4: '您转账的HKD会按照汇率转换成相应资产空投到您的资产账户。',
		complete_transfer: '完成转账',
		copy_success: '复制成功',
		submit_fail: '提交失败',
		success_modal_title: '重要提示',
		success_modal_content: '转账完成后，运营会尽快完成审核，审核通过后按汇率转换成相应资产空投到您的资产账户，请注意查看，路径：资产 – RWA代币。',
		success_modal_btn: '我知道了',
		confirm_modal_title: '确认提交',
		confirm_modal_content: '请确认转账信息填写无误，提交后将进入审核，无法修改。是否确认提交？',
		confirm_modal_confirm: '确认提交',
		confirm_modal_cancel: '再检查一下',
		min_amount_tip: '最低充值100 HKD',
		input_transfer_account: '请输入转账账户',
		input_transfer_name: '请输入转账人姓名'
	},
	user_assets: {
		bankAccountNumber: '银行账号',
		overview: '资产概览',
		total_assets: '总账户资产折合',
		ctc_account: '币币账户',
		little_assets_hide: '隐藏小额资产',
		member_card_title: '会员套餐',
		my_card_title: '我的点卡',
		check_detail: '查看详情',
		search: '搜索币种',
		coin_type: '币种',
		available_balance: '可用余额',
		freeze_balance: '冻结余额',
		redeem: '赎回中',
		valuations: '估值',
		operation: '操作',
		recharge: '充币',
		withdraw: '提币',
		validate_warning: '需要开启至少两种验证方式，请去个人中心开启',
		can_not_recharge: '该币种充币功能暂时关闭',
		can_not_withdraw: '该币种提币功能暂时关闭',
		record: '交易记录',
		recharge_address: '充币地址',
		blockchain_type: '链类型',
		address_type: '地址类型',
		new_address: '新地址',
		old_address: '旧地址',
		check: '查看',
		recharge_record: '充币记录',
		copy_address: '复制地址',
		copy_memo: '复制Memo',
		copy_success: '复制成功',
		copy_error: '复制失败',
		min_recharge: '最小充值金额：',
		recharge_warning: '小于最小金额的充值将不会上账且无法退回。',
		memo_warning: '务必准确填写',
		tip_title: '温馨提示：',
		tip_con: '1.请勿向上述地址充值任何非 ETH 资产，否则资产将不可找回。<br>2.您充值至上指定地址后，需要 X 个网络确认才能到账。<br>' +
			'3.您的充值地址不会经常改变，可以重复充值；如有更改，我们会尽量通过网站公告或邮件通知您。<br>' +
			'4.请务必确认电脑及浏览器安全，防止信息被篡改或泄露。',
		choice_address: '选择提币地址',
		choice_address_placeholder: '请选择提币地址',
		withdraw_record: ' 提币记录',
		add_address: '添加新地址',
		withdraw_amount: '提币数量',
		available: '可用数量：',
		withdraw_amount_placeholder: '请输入提币数量',
		withdraw_amount_placeholder1: '最小提币数量为',
		withdraw_amount_placeholder2: '最大不超过',
		min_withdraw: '最小提币金额为',
		withdraw_warning: '优先从余额中扣除，当余额不足则从提币数量中扣除',
		withdraw_success: '提现成功',
		trans_password: '交易密码',
		trans_password_placeholder: '请输入交易密码',
		buy_member: '您即将购买会员套餐，购买会员套餐后将享受会员权益，请先确认币币账户余额充足',
		buy_amount: '购买数量',
		should_pay: '应付金额',
		pay_confirm_title: '确认付款',
		pay_confirm: '确认支付',
		pay_success: '购买成功',
		available_not_enough: '余额不足',
		need_whole_number: '输入值必须是正整数',
		cancel: '取&nbsp;&nbsp;&nbsp;&nbsp;消',
		phone_code: '短信验证码',
		phone_code_placeholder: '请输入短信验证码',
		email_code: '邮箱验证码',
		email_code_placeholder: '请输入邮箱验证码',
		get_code: '获取验证码',
		phone_bind: '绑定手机号',
		email_bind: '绑定邮箱',
		google_code: '谷歌验证码',
		google_code_placeholder: '请输入谷歌验证码',
		memo_tip: '·Memo错填、漏填可能导致资产损失，请仔细核对<br><label class="font_color_red">·转入交易所地址时必须填</label>',
		memo_placeholder: '请输入MEMO',
		actual: '实际到账数量：',
		fee: '手续费：',
		withdraw_btn: '提&nbsp;&nbsp;&nbsp;&nbsp;币',
		my_dk: '我的点卡',
		available_dk: '点卡余额',
		buy_dk: '点卡购买',
		dk_desc: '点卡是RWA平台推出的交易手续费充值卡，1点卡（dk）=1 USDT等值的交易手续费。',
		buy_placeholder: '请输入购买数量',
		buy_btn: '购&nbsp;&nbsp;&nbsp;&nbsp;买',
		min_buy_amount: '最少购买金额',
		min_amount_warning: '购买金额不能少于最小金额',
		available_usdt: '可用USDT',
		api: {
			tips_val_1: '私有秘钥允许您通过RWAEx开放协议提供API访问您的账户并执行交易指令，我们为您提供的秘钥非常重要，请妥善保管。',
			setting: 'API设置',
			check_document: '查看API文档',
			attentionVal1: '1. 本平台提供强大的API接口服务，包括市场数据查询、交易等。请参考API文档使用。商户域名：openapi.rwa.ltd',
			attentionVal2: '2. 每个用户最多可创建5个API密钥集。',
			attentionVal3: '3.不要公开你的API密钥以防止经济损失。出于安全考虑，我们建议将IP地址绑定到你的API密钥上。',
			attentionVal4: '4. 每个API密钥支持绑定最多5个IP地址。用逗号分隔多个IP地址。',
			attention: '<label style="color: #F04C66">注意事项:</label><br>· 我们提供 REST 和 WebSocket API，可查阅API文档。<br>· 每个用户最多可创建10对API密钥。<br>' +
				'· 针对交易API，单个IP限制每分钟1000次访问，超过1000次将被锁定1小时，一小时后自动解锁。<br>' +
				'· 针对交易API，单个API限制每秒钟60次访问，一秒钟内60次以上的请求，将会视作无效。<br>· K线接口每秒只能请求一次数据。<br>' +
				'· 如果在使用过程中有任何问题，请加QQ群 710574280 我们将为您做出最权威的解答。',
			add: '添加新API',
			fill_info: 'API秘钥资料填写',
			role_api: 'API密钥权限',
			api_check: '查询资产：查询账号信息及资产情况',
			api_trade: '委托交易：委托、取消、查询交易订单',
			remarks: '备注',
			remarks_placeholder: '备注API名称',
			bind_ip: '绑定IP地址（选填）',
			remark_placeholder: '备注API名称',
			bind_placeholder: '可加多个，用“，”分割',
			create_key: '创建API秘钥',
			my_key: '我的API秘钥',
			id: '序号',
			operation: '操作',
			alert_title: 'API秘钥',
			show_once: '仅显示一次，若遗忘请重新生成',
			visit_key: 'API访问秘匙（Access Key）',
			private_key: 'API私有秘匙（Secret Key）',
			copy: '复制',
			important_info: '重要提示：<br>私有秘钥允许您通过RWAEx开放协议提供API访问您的账户并执行交易指令，' +
				'我们为您提供的秘钥非常重要，请妥善保管。',
			confirm: '确&nbsp;&nbsp;&nbsp;&nbsp;定',
			delete_api: '删除',
			delete_confirm: '确定删除',
			cancel: '取消',
			delete_success: '删除成功'
		},
		web_record: {
			tabTypeValue1: 'RWA代币',
			tabTypeValue2: '资金',
			membershipPackage: '会员套餐',
			searchTitle: '账户',
			info: '信息',
			transaction: '交易',
			title: '交易记录',
			recharge: '充币',
			recharge2: '充值',
			rechargeAddress: '充值地址',
			rechargeTips: '请您在充值时，仔细核对充值信息，避免因信息错误导致资产损失',
			rechargeTips1: '请您保证充值数量不小于',
			rechargeTips2: '不大于',
			rechargeTips3: '避免因数量错误到账资产损失',
			withdraw: '提币',
			ctc: '币币',
			buy: '买入',
			fiatCurrency: '法币',
			sell: '卖出',
			other: '其他',
			search: '搜索币种',
			input_coin: '输入币种',
			time: '时间',
			type: '类别-币种',
			amount: '数量',
			status: '状态',
			success: '成功',
			fail: '失败',
			complete: '已完成',
			status_applied: '已申请',
			status_checked: '已审核',
			status_send: '已下发',
			status_confirm: '确认中',
			status_withdraw: '  提现成功',
			status_refused: '已拒绝',
			status_cancel: '已取消',
			recharge_address: '充币地址',
			withdraw_address: '提币地址',
			operation: '操作',
			cancel: '取消',
			cancel_success: '取消成功',
			check_detail: '查看详情',
			account_balance: '账户余额',
			wallet_handle_time: '钱包处理时间',
			trade_id: '交易ID',
			desc: '说明',
			fee: '手续费',
			dk: '消耗DK',
			rebate: '返佣',
			burst_block: '爆快',
			block_detail: '爆块详情',
			prize: '中奖金额',
			prize_order: '中奖订单号',
			prize_tip: '恭喜您参与的爆块活动成功中奖，奖励会在24小时内自动发放至您的币币账户，请注意账户余额变化。',
			block_detail_h2: '尊敬的用户，恭喜您爆块成功，并瓜分四位奖池',
			transfer: '转账',
			mall: '商城',
			coin_type: '币种',
			flow_type: '类型',
			all: '全部',
			mall_pay: '商城支付',
			mall_distribute: '商城分发',
			completed: '已完成'
		}
	},
	rechargeCoins: {
		coin_type: '币种',
		chain_type: '链类型',
		recharge_address: '充值地址',
		notice: '温馨提示',
		notice_content1: '请确保您选择的链类型与转出平台一致，否则可能导致资产丢失',
		notice_content2: '请务必填写正确的充值地址，错误地址将导致资产无法找回',
		copy_success: '复制成功',
		copy_fail: '复制失败'
	},
	sellOrder: {
			search_placeholder: '搜索订单号',
			all: '全部',
			completed: '已完成',
			pending_distribution: '待分发',
			pending_payment: '待支付',
			cancelled: '已取消',
			order_id: '订单号',
			subscription_shares: '认购份数',
			payment_price: '支付价格',
			total_payment: '支付总额',
			order_time: '下单时间',
			cancel_order: '取消订单',
			go_pay: '去支付',
			load_complete: '已全部加载完毕',
			pay: '支付',
			pay_amount: '支付金额',
			pay_method: '支付方式',
			balance: '余额',
			trade_password: '交易密码',
			password_placeholder: '请输入交易密码',
			confirm_pay: '确认支付',
			pay_success: '支付成功',
			confirm: '确认',
			cancel_tip: '提示',
			cancel_confirm: '确定取消此订单？',
			cancel_success: '取消成功',
			cancel_fail: '取消失败',
			pay_fail: '支付失败',
			password_required: '请输入交易密码',
			status_completed: '已完成',
			status_pending_distribution: '待分发',
			status_pending_payment: '待支付',
			status_cancelled: '已取消',
			recharge: '充值',
			set_password: '设置',
			insufficient_balance: '余额不足',
			cancel: '取消'
		},
	sellOrderDetails: {
		payment_countdown: '付款倒计时',
		subscription_shares: '认购份数',
		subscription_amount: '认购数量',
		issue_price: '发行价格',
		total_payment: '支付总额',
		order_time: '下单时间',
		distribution_time: '分发时间',
		transaction_time: '交易时间',
		order_no: '订单号',
		copy: '复制',
		asset_tip: '查看我的资产',
		cancel_order: '取消订单',
		go_pay: '去支付',
		back_to_order_list: '返回订单列表'
	},
	withdrawCoins: {
		coin_type: '币种',
		chain_type: '链类型',
		address: '提现地址',
		withdraw_amount: '提币数量',
		available: '可用数量',
		fee: '手续费',
		notice: '温馨提示',
		notice_content1: '请确保您选择的链类型与转入平台一致，否则可能导致资产丢失',
		notice_content2: '请务必填写正确的提现地址，错误地址将导致资产无法找回'
	},
	confirmBuy: {
		title: '确认购买',
		subscription_shares: '认购份数',
		available: '可认购份数',
		shares: '份',
		per_share: '份',
		subscription_value: '认购价值',
		issue_price: '发售价格',
		payment_total: '支付总额',
		payment: '支付币种',
		pay_from: '从资产账户付款',
		balance: '资产余额',
		recharge: '去充值',
		cancel: '取消',
		confirm_buy: '确认购买',
		trade_password: '请输入交易密码',
		confirm_pay: '确认支付',
		processing: '处理中...',
		enter_password: '请输入交易密码',
		pay_fail: '支付失败',
		order_create_fail: '订单创建失败',
		pay_success: '支付成功',
		tip: '提示',
		exceeded: '超出限购',
		exceeded_tip: '已超过最大可购买数量',
		insufficient_balance: '余额不足',
		unpaid_order_exists: '您存在未支付的订单',
		goto: '去查看'
	},
	wallet: {
		charging: {
			amount: '充值数量',
			amount_placeholder: '请输入充值数量',
			hkd_account: '请将港币转入以下账户',
			receive_account: '收款账户',
			company: '开户公司',
			bank: '开户银行',
			bank_info: '为方便审核，请提供您的转账银行卡信息',
			transfer_account: '转账账户',
			name: '转账人姓名',
			transaction_no: '转账流水号',
			input_placeholder: '请输入',
			confirm_tip: '转账完成后请点击完成转账',
			complete: '完成转账',
			tip1: '请务必确认到账数量和输入数量一致，数据不一致会造成充值失败',
			tip2: '转账完成后，等待后台审核，一般24小时内到账。',
			tip3: '特殊情况，可联系客服人员，提供充值订单号咨询。',
			amount_required: '请输入充值数量',
			account_required: '请输入转账账户',
			name_required: '请输入转账人姓名',
			submit_success: '转账已提交，等审核通过后即可到账。',
			submitted_title: '已提交',
			submitted_desc: '转账已提交，请等待审核，通过后即可到账。',
			view_records: '查看充币记录'
		}
	},
	burst: {
		header: {
			h1: '每天晚上8点整出爆块号码<br>你的订单号后7位与爆块号相同，即中大奖！',
			h3: 'RWA交易所首创，爆块号码绝对公平公正',
			four_digit: '四位奖池已累计：',
			seven_digit: '七位奖池已累计：',
			nav1: '本期公/私钥对',
			nav2: '公/私钥关系验证',
			nav3: '点击查看爆块活动规则'
		},
		q1: {
			title: '1.什么是爆块？',
			con: '此玩法为RWA 交易所首创，RWA交易所将拿出手续费收入的30%投入奖池中，' +
				'用户交易产生的币币交易订单号后4位或7位阿拉伯数字符合当期爆块号码的后4位或7位数字的，则爆块成功。' +
				'根据活动规则瓜分奖池，奖励将在24小时内自动发放。',
			table_title: 'EOS实时出块数据',
			time: '出块时间',
			block_num: '区块号',
			hash: '哈希值',
			link: '由<a href="https://eospark.com/" target="_blank" style="color: #42CB83;">eospark.com</a>提供数据支持'
		},
		q2: {
			title: '2.如何参与爆块？',
			con: '总奖池资金为RWA交易所手续费收入的30%，将按20%放入7位奖池，将10%放入4位奖池。 ' +
				'24小时内，用户在币币交易区交易金额满10USDT的订单均可参与“爆块”活动。符合哈希值后4位的用户瓜分4位奖池资金，' +
				'符合哈希值后7位的用户瓜分7位奖池资金。',
			trade_now: '立即交易'
		},
		q3: {
			title: '3.奖励如何发放？',
			con: '每日20:00:00（UTC+8）时自动开奖，奖品会在24小时内发放至用户的币币账户，届时将短信通知中奖用户。',
			table_title1: '往期开奖信息公示',
			table_title2: '我的有效订单',
			time: '日期',
			key: '公/私钥对',
			hash: '哈希值',
			reward: '开奖值',
			publicKey: '公钥',
			privateKey: '私钥',
			orderNum: '订单号',
			status: '状态',
			rewardMoney: '中奖金额',
			drawn_prize: '中奖',
			drawn_no_prize: '未中奖'
		},
		alert: {
			title_key: '本期公私钥对',
			publicKey: '公钥',
			privateKey: '私钥',
			not_yet_published: '暂未公布（下午20:00:00公布）',
			back: '返&nbsp;&nbsp;&nbsp;&nbsp;回',
			title_rules: '爆块活动规则',
			rules_con: '选取一对公私钥对，每日上午8:00:00（UTC+8）对外公布公钥。<br><br>' +
				'EOSIO主网每秒产出两个区块，我们取当日整点20:00:00（UTC+8）生成的两个区块，<label style="color: #A0AAC1">' +
				'前一个区块的后4位数字，后一个区块的后7位数字，分别与私钥的最后4位、最后7位数字相加，取最终结果的最后4位、7位数字。' +
				' （如有字母则跳过，如相加结果超过4位、7位，只取相加结果的后4位与后7位。）</label><br><br>' +
				'若用户的币币交易订单号满足交易额10USDT，且后4位或后7位与爆块号码相同，则瓜分奖池奖金。<br><br>' +
				'<label style="color: #A0AAC1;"> 例，2019年7月2日上午8时公布公钥：<br>EOS7wW1bAdMqVERBvFShcADXpLhTrs5oWSkzK7vkwosSvrqP5e2nq <br><br>' +
				'下午20时公布区块哈希值： <br>前：03f9bf71d0e75e131fd75508091c0c64609a3ff9af71be496728e97ef' +
				'<label style="color: #42CB83">953</label>f<label><label style="color: #42CB83">3</label>ba</label>' +
				'<br>后：03f9bf727c3b3be0f9f6c36f8d1bebc0720fe2e65fd4d7f<label style="color: #42CB83">0</label>e<label style="color: #42CB83">88</label>cf' +
				'<label style="color: #42CB83">6</label>bf<label style="color: #42CB83">21</label>d<label style="color: #42CB83">4</label>eebb<br>' +
				'私钥：5JFyWm2Dx8ywKwEC2bvSUEnZE<label style="color: #42CB83">1</label>rGSCPT<label style="color: #42CB83">18</label>ijAwarJKrp' +
				'<label style="color: #42CB83">579</label>Qe<label style="color: #42CB83">6</label>k<br><br>' +
				'开奖数值为： <br>9533+5796=15329<br>0886214+1185796=2072010<br><br>若用户订单号尾数为5329或2072010，则满足获奖条件。</label><br><br><br>' +
				'开奖提示：<br>用户应知悉，公私钥生成使用的是RSA非对称加密算法，通过私钥可导出公钥，但此推导过程不可逆，因此每产生一个公钥，' +
				'就一定有其对应的私钥，且不可更改。<br><br>EOSIO主网每秒产生两个区块，区块哈希值随机产生，无法被人为控制。' +
				'<br><br>提前公布公钥，意味着私钥的不可更换；选取哈希值作为开奖元素，意味着无法人为控制。本活动开奖公平、公正，支持用户查询验证。'
		}
	},
	notification: {
		system: {
			nav: '系统通知',
			login_check: '登录后可查看',
			mark_all: '全部标记已读',
			mark_success: '标记成功'
		}
	},
	partner: {
		h1Title1: "加入RWA会员计划",
		h1Title2: "持续拉新返利 & 限时福利活动",
		spanVal: '如何轻松赚取返现？',
		spanVal01: '注册登录RWA.LTD',
		spanVal02: '使用邮箱注册登录',
		spanVal03: '购买会员套餐成为会员',
		spanVal04: '支付100USD/782HKD/100USDT',
		spanVal05: '获取并分享邀请链接',
		spanVal06: '邀请您的好友进行注册',
		spanVal07: '获取会员奖励',
		spanVal08: '邀请更多好友，获取返现奖励',
		becomeMember: '成为会员',
		memberTips: '您还不是会员，购买100USD点卡成为交易所会员，享会员权益',
		memberTips1: '立即成为平台会员',
		memberTips2: '邀请更多好友，赚取更多奖励',
		memberTips3: '邀请更多好友，赚取更多奖励',
		memberTips4: '您即将购买会员套餐，购买会员套餐后将享受会员权益，请先确认现货账户余额充足',
		memberTips5: 'RWA.LTD会员套餐',
		memberTips6: '成为交易所会员，赢40%交易返佣奖励',
		memberTips7: '恭喜您成为会员',
		memberTips8: '立刻邀请好友，赢取交易返佣！',
		memberTips9: '您已成为平台会员',
		memberWorth: '价值',
		memberPay: '需支付',
		memberNowPay: '立即支付',
		memberVip: '等级',
		shareList: '邀请数据',
		shareListTips: '实时发放邀请好友开通会员的奖励，直接发放到USD资产钱包中，请注意查收。',
		rebateRatio: '返佣比例',
		cumulativeRebate: '累计返佣',
		cumulativeCashback: '累计返现',
		cumulativeCashback1: '累计邀请(直邀)人数',
		shareTab1: '邀请排行',
		shareTab2: '邀请记录',
		shareTab3: '返佣记录',
		questionsTitle: '常见问题',
		questionsVal1: '是否存在返佣上限?',
		questionsVal2: '是的。出于合规考虑，RWA.LTD为每位会员设定了每月1000USD的返佣及现金返还总额上限。',
		questionsVal3: '成为会员后，如何获得邀请返佣?',
		questionsVal4: 'A邀请好友B在交易所注册。当B在交易所进行交易时，A可获得40%的交易手续费返佣。若B再邀请C注册，当C进行交易时，B可获得40%的交易手续费返佣，同时A可获得10%的交易手续费返佣。',
		questionsVal5: '成为会员后，如何获得交易现金返还(cashback)?',
		questionsVal6: '若A邀请的好友B成为交易所会员，A可获得20USD/USDT的现金返还。若B再邀请C成为交易所会员，则B可获得20USD/USDT的现金返还，而A可获得10USD/USDT 的现金返还。',
		questionsVal61: '会员计划是否有时间限制?',
		questionsVal62: '截止至前，该计划未设定时间限制。但RWA.LTD保留随时自行决定对该计划进行修改、暂停或终止的权利，且无需事先通知。',
		questionsVal7: '成为会员后有哪些权益？',
		questionsVal8: '成为会员后，您将享有以下权益：',
		questionsVal81: '1.推荐返现：下级好友购买会员套餐后，您可获得返现奖励。',
		questionsVal82: '2.交易手续费折扣：自购买日起，365天内平台交易手续费可享受5折优惠。',
		questionsVal83: '3.100USD会员费可抵扣50%的手续费，在抵扣期间，由于会员享有5折手续费优惠，需再支付的手续费仅为初始费用的25% 。',
		header_con1: '与用户共享平台福利',
		header_con2: '百万富翁合伙人计划',
		header_con3: '会员招募中',
		not_login: '您还未登陆',
		please_login: '请先登录',
		need_set_password: '需要设置交易密码',
		set_now: '去设置',
		not_yet_member: '您还不是会员',
		not_yet_partner: '您还不是合伙人',
		update_now: '立即升级',
		is_vip: '您好，您目前的等级为',
		my_reward: '我的收益折合(USDT)',
		rwa_register: '注册用户',
		rwa_member: 'RWA会员',
		rwa_partner: 'RWA合伙人',
		rwa_diamond: 'RWA钻石合伙人',
		create_poster: '生成海报',
		my_invite_code: '我的邀请码',
		share_invite_code: '分享邀请链接',
		my_invite_code_url: '我的邀请码链接',
		copy_success: '复制成功',
		copy_fail: '复制失败',
		invite_reward_withdraw: '点卡返现',
		second_invite_reward_withdraw: '二级点卡返现',
		invite_reward_fee: '交易返佣比例',
		second_invite_reward_fee: '二级交易返佣比例',
		invite_amount: '邀请人数',
		invite_up_member: '我的一级会员',
		invite_upup_member: '我的二级会员',
		volume_24h: '24H交易笔数',
		reward_withdraw_24h: '24H已返佣',
		reward_fee_total: '我的交易返佣',
		reward_withdraw_total: '我的邀请返现',
		reward_cash_total: '返现金额',
		title1: '1. 什么是会员制交易所？',
		table_title1: 'RWA交易所会员权益及返佣规则',
		table_title2: 'RWA交易所各级会员要求',
		dk_reward: '点卡返现',
		trans_reward_fee: '交易返佣',
		up_trans_reward_fee: '二级交易返佣',
		level: '等级',
		up_dk_reward: '二级点卡返现',
		fee_discount: '手续费折扣',
		need: '需要',
		no_need: '不需要',
		real_name: '实名认证',
		buy_dk: '购买点卡',
		need_invite_amount: '邀请人数要求',
		need_trans_money: '交易金额要求',
		con1: 'RWA交易所的会员可以享受平台的诸多权益，而平台的定位是交易所技术服务方，平台将交易所利润让渡给会员，让会员享受更多的收益，成为交易所的“老板”。 <br>' +
			'RWA平台通过会员制吸引优质用户加入社区，采用社区共建、让利会员的方式打造强大的RWA社区，进一步打造全球第一会员制交易所。',
		example1: '例：<br><p style="color: #222A55; font-size: 16px;">1）A是RWA交易所的注册用户，那么A怎么成为交易所会员呢？</p>' +
			'A想成为交易所会员，只需要直接购买100USDT点卡，就可以成为交易所会员了。' +
			'<p style="margin-top: 30px;color: #222A55; font-size: 16px;">2）成为会员后，A怎么获得邀请返佣？</p>' +
			'A邀请好友B注册RWA交易所，B在交易所交易时，A可以获得40%交易手续费的返佣<br>' +
			'B又邀请了C注册，C在交易时，B可以获得40%交易手续费返佣，A可以获得10%交易手续费返佣。' +
			'<p style="margin-top: 30px;color: #222A55; font-size: 16px;">3）成为会员后，A怎么获得交易返现？</p>' +
			'如果A邀请的好友B也成为了交易所会员，A可以获得20USDT返现<br>' +
			'如果B邀请的C也成为交易所会员，那么B可以获得20USDT返现，A可以获得10USDT返现。',
		title2: '2. 如何成为交易所会员和更高级的合伙人？',
		con2: '用户购买100USDT点卡成为RWA平台会员后，' +
			'只要满足邀请会员人数要求、交易金额要求这两项指标后，即可自动升级成为更高级的合伙人。',
		example2: '例：<br><p style="color: #222A55; font-size: 16px;">1）A已经是交易所会员了，那么如何升级成为合伙人呢？</p>' +
			'A直推邀请至少2名会员（包含会员以上身份），并且在RWA平台交易额满10000USDT（包含Taker与Maker），即可成为RWA合伙人；<br>' +
			'A直推邀请至少5名会员（包含会员以上身份），并且在RWA平台交易额满50000USDT（包含Taker与Maker），即可成为RWA钻石合伙人；<br>' +
			'<p style="margin-top: 30px">会员是指购买100USDT点卡的用户。</p>',
		example2_2: '<p style="color: #222A55; font-size: 16px;">2）我已经是会员，可以购买会员权益赠送他人吗？</p>' +
			'在您已经是会员的前提下，可以通过购买会员权益，生成指定的会员邀请码，帮助他人一键注册成为会员。<br>' +
			'当对方使用您的会员权益邀请码注册成功后，即可一步成为会员身份，无需经过其他步骤。 <br>' +
			'每个会员权益邀请码仅可使用一次，注册成功即失效。',
		btn_be_member: '立即成为交易所会员',
		btn_detail: '会员权益详解',
		btn_gift: '购买会员权益卡赠与他人',
		btn_check: '查看会员权益卡使用情况',
		title3: '3.返佣如何发放？',
		con3: '每天08：00:00 (GMT+0800) 将返还前24小时邀请邀请奖励，直接发放到币币账户，请注意查收。',
		reward_cash_rank: '返现排行榜',
		invite_record: '我的邀请记录',
		reward_record: '我的返佣记录',
		rank: '排名',
		partner_lvl: '合伙人等级',
		user: '用户',
		time: '时间',
		user_invited: '受邀人',
		reward_cash_amount: '返现金额',
		reward_fee_money: '返佣金额',
		btn_alert: '开始我的特权之旅',
		buy_card: '购买会员权益卡',
		pay_after: '付款后显示邀请码',
		create_invite_code: '生成邀请码',
		assign_user: '指定用户',
		pay_con: '您即将购买会员权益卡，购买会员权益卡后可以赠与他人，请先确认币币账户余额充足',
		should_pay: '应付金额',
		trade_password_placeholder: '请输入交易密码',
		uid_placeholder: '请输入用户UID',
		uid_error: '非法UID',
		check: '校验',
		not_check: '请先进行身份校验',
		check_fail: 'UID校验失败，无法为其购买会员',
		is_follow_me: '此用户为您的直邀用户',
		not_follow_me: '此用户不是您的直邀用户，请谨慎购买',
		pay_confirm: '确认支付',
		be_member: '已经成为会员',
		cancel: '取消',
		buy_complete: '购买完成',
		click_copy: '点击复制',
		success_con: '当他人使用您的邀请码进行注册时，即可一步成为会员身份。每个邀请码仅可使用一次，注册成功即失效',
		close: '关闭',
		has_buy_card: '已购买的权益卡',
		buy_time: '购买时间',
		invite_code: '邀请码',
		direct: '直升',
		status: '状态',
		status_0: '未认证',
		status_1: '已认证',
		status_2: '审核中',
		status_3: '审核失败',
		code_user: '使用人',
		operation: '操作',
		copy: '复制',
		not_use: '未使用',
		invalid: '已失效',
		must_member: '只有会员才可以购买权益卡',
		activity: {
			title: "会员权益",
			content1: "持续拉新返利",
			content2: "1. 交易手续费返佣：会员A（“推荐⼈”）邀请会员B（“被推荐⼈”）在 RWA.LTD 注册。当会员B进⾏交易时，会员A可获得B交易手续费的 40% 返佣。若会员B进—步推荐会员C，则：",
			content2$1: " - 会员B可获得C交易⼿续费的 40% 返佣；",
			content2$2: " - 会员A可获得C交易⼿续费的 10% 返佣。", 
			
			content2$2$0: "2. 推荐奖励：会员A推荐会员B在 RWA.LTD 注册后，会员A可在B成功注册后获得 20美元（或等值USDT）注册奖励。若会员B进—步推荐会员C，则：",
			content2$2$1: " - 会员B可获得 20美元（或等值USDT）注册奖励；",
			content2$2$2: " - 会员A可获得 10美元（或等值USDT）⼆级推荐奖励。",
				
			content3: "限时福利活动",
			content3$0: "1. 空投礼包：价值100美元的优质消费资产代币【活动时间：2026年3⽉19⽇ – 2026年4⽉19⽇】",
			content3$1:	" - 空投内容：150 RWA + 300 DIMD + 300 GCT + 300 TOP100 ",
			content3$2:	" - 发放规则：每周⽇统计会员数据，并按顺序发放资产礼包；所有资产将在 三个⽉内全部发放完成。",
			
			content3$2$0: "2. 五折交易⼿续费优惠【有效期：1年】",
			content3$2$1: " - ⼿续费折扣：会员在—年内享受所有交易对50%的交易⼿续费折扣——交易越多，节省越多。",
			content3$2$2: " - 会员费抵扣机制：已⽀付的价值100美元会员费可⽤于抵扣最多50%的交易⼿续费。在抵扣期间，叠加50%⼿续费折扣后，会员实际⽀付的⼿续费仅为原始⼿续费的25%。",
			
			content4: "2026 年 3 月 19 日至 2026 年 3 月 20 日",
			content5: "三、活动福利",
			content6: "福利 1：价值 100USD 的平台优质资产大礼包空投",
			content7: "活动期间新开通会员，额外获赠总价值 100 USD 的优质消费品 RWA 资产组合大礼包。",
			content8: "空投内容：150 RWA + 300 DIMD + 300 GCT + 300 TOP100",
			content9: "发放规则：每周日统计会员数据，依次空投一种资产礼包，全部资产礼包将于 3 个月内全部发放完毕。",
			content10: "福利 2：年度会员专属权益",
			content11: "手续费 5 折：1 年内所有交易对手续费享受 5 折 优惠，交易越多，节省越多。",
			content12: "会员费抵扣手续费：您支付的 100USD 会员费，可直接用于抵扣未来产生交易手续费的 50%，相当于在交易手续费 5 折基础上再享 5 折优惠。",
			content13: "福利 3：邀请推介，立享返现",
			content14: "直推奖励：直接邀请好友开通会员，您可获得 20USD/USDT 返现。",
			content15: "间推奖励：好友再邀请他人，您还可获得 10USD/USDT 返现。"
		}
	},
	about: {
		title: '关于我们',
		titleInfo: 'RWA.LTD是由香港国际新经济研究院(INERI)通过其全资子公司RWAGroup Limited打造的全球首家专注于非金融现实世界资产(RealWorld Assets,RWA)代币的交易平台，在香港法下作为“有限用途数码代币(Limited Purpose Digital Token)”交易平台合规运营。',
		titleInfo1: '香港国际新经济研究院(INERI)由CEO付饶先生于2019年创立，是香港科技园(HongKong Science and Technology Parks)的孵化企业之一，并接受香港特区政府的多项津贴。在成立初期，INERI的主要业务为区块链赋能产业咨询。付饶先生亦长期参与高校教学与研究工作，曾担任香港大学、香港城市大学、香港中文大学(深圳)以及北京大学的客座讲师。自2023年起，INERI开始重点布局非金融类RWA的代币化应用。其创立的NFT China平台通过与比亚迪(BYDDY)等知名企业合作，主导并推动了多个非金融类NFT项目的发行。平台在上线三个月内即获得超过30万注册用户。',
		titleInfo2: '在丰富的NFT平台运营经验及产业资源基础上，INERI自2024年年底起启动非金融同质化代币(FT)平台的筹备工作。RWALTD平台于2025年9月中旬正式上线，成为全球首个专注于交易有限用途数码代币的平台，致力于通过区块链技术实现非金融权益的数字化表达与流通。2026年3月，RWA.LTD完成首次平台升级与系统改版，进一步提升了平台的安全性、稳定性与用户体验，持续推动非金融RWA代币化生态的发展。'
	},
	footerAddress: {
		btnVal1: '搜索',
		btnVal2: '清除',
		btnVal3: '电话',
		inputPlaceholder: '请输入地点名称'
	},
	download: {
		title: 'RWA应用下载',
		title1: '链商平台 重磅来袭',
		title2: '代币机制和商品经济的创新性结合，为您带来全新体验',
		h3: '安全、稳定、高效的',
		h1: '数字资产交易平台',
		ios: 'IOS下载',
		android: 'Android下载'
	},
	financial: {
		home: {
			header: 'RWAEx 理财宝',
			tip: '是一个区块链资产持币生息，稳定型收益投资平台，包括定期（锁仓理财），活期理财等多种类型的产品，为稳健型投资用户提供最佳投资渠道',
			my_had: '我的持币',
			ongoing: '正在进行',
			mining: '挖矿中',
			tobe_started: '即将开始',
			end: '已经结束',
			rate_year: '参考年化',
			auto: '灵活',
			buy_min: '起购',
			mine_min: '起挖',
			assign_coin: '利息币种',
			to_end_time: '距离抢购结束',
			left_position: '剩余仓位',
			lock_position: '已锁仓位',
			day: '天',
			hour: '时',
			minutes: '分',
			seconds: '秒',
			after_start: '后开始',
		}
	},
	footerPrivacy: {
		title: '隐私声明',
		titleInfo: '本隐私声明由 RWA Group（下称“我们”或“本公司”；“RWA Group的”为“我们的”）向您作为本平台[RWA.LTD]、网站[https://www.rwahk.ltd/]以及任何相关的电脑或移动应用程序的访客或用户作出。RWAGroup 指 RWA GroupLimited（一家在香港注册成立的有限公司，商业登记号码为74645397）。本声明是根据《个人资料（私隐）条例》（“《私隐条例》”）而制定。',
		titleInfo1: '第一部分：个人资料收集声明（PICS）',
		titleInfo2: 'A. 收集目的',
		titleInfo3: '我们收集和储存您的个人资料，以提供和优化我们的服务，包括但不限于：',
		titleInfo4: '(a)创建和管理您的用户账户;',
		titleInfo5: '(b)根据反洗钱（AML）及打击恐怖分子资金筹集（CFT）规定核实您的身份;',
		titleInfo6: '(c)处理您的交易（包括充值、提现及交易）;',
		titleInfo7: '(d)发送行政通知及（在允许的情况下）市场推广信息;',
		titleInfo8: '(e)遵守适用的法律义务或监管要求。',
		titleInfo9: 'B. 收集的个人资料类别',
		titleInfo10: '我们可能收集的个人资料包括：',
		titleInfo11: '(a) 身份识别资料（例如：姓名、香港身份证/护照号码）;',
		titleInfo12: '(b) 联络资料（例如：电邮地址、电话号码、住址）;',
		titleInfo13: '(c) 财务及交易资料（例如：钱包地址、交易记录、银行账户信息）;',
		titleInfo14: '(d) 设备及使用数据（例如：IP 地址、浏览器类型、Cookies）。',
		titleInfo15: 'C. 不提供资料的后果',
		titleInfo16: '提供个人资料一般为自愿性质。然而，某些资料为使用本服务所必须提供。如您未能提供该等资料，我们可能无法向您提供产品或服务，包括但不限于：',
		titleInfo17: '(a) 开立或维持您的账户;',
		titleInfo18: '(b) 处理您的交易;',
		titleInfo19: '(c) 遵守法律或监管要求。',
		titleInfo20: 'D. 资料披露对象类别',
		titleInfo21: '我们可能会将您的个人资料披露予以下类别的人员：',
		titleInfo22: '(a) 我们的关联公司及服务供应商（例如：KYC 服务提供商、支付处理机构）;',
		titleInfo23: '(b) 法律要求下的政府机关、监管机构或执法机构;',
		titleInfo24: '(c) 负有保密责任的法律、财务或专业顾问。',
		titleInfo25: 'E. 直接促销',
		titleInfo26: '我们可能会使用您的姓名、手机号码、电邮地址及住址，向您发送有关我们服务和产品的市场推广信息。除非我们已获得您的同意或您未表示反对，否则我们不会使用您的个人资料作直接促销用途。您可随时通过 [s@rwa.ltd] 联系我们，选择退出接收市场推广信息。',
		titleInfo27: 'F. 查阅及改正权利',
		titleInfo28: '您有权根据《私隐条例》查阅及要求改正我们所持有的您的个人资料。有关申请请以书面形式发送至 [s@rwa.ltd]。',
		titleInfo29: '第二部分：私隐政策声明（PPS）',
		titleInfo30: 'A. 所持个人资料种类',
		titleInfo31: '我们保存的个人资料种类包括：',
		titleInfo32: '(a) 用户注册及身份识别资料;',
		titleInfo33: '(b) 交易及活动记录;',
		titleInfo34: '(c) 与用户的通讯记录',
		titleInfo35: '(d) Cookies 及技术使用数据。',
		titleInfo36: 'B. 使用的主要目的',
		titleInfo37: '个人资料的使用目的与上述 PICS 中列明的目的相同。',
		titleInfo38: 'C. 资料保存',
		titleInfo39: '我们仅在为达成本资料收集目的所需的期间内或依照法律要求（例如：AML/CFT 规定）保留您的个人资料。相关期限届满后，该资料将被安全删除或匿名化处理。尽管有上述规定，您已在《平台使用协议》中同意我们可保存特定信息长达六（6）年。',
		titleInfo40: 'D. 安全措施',
		titleInfo41: '我们采取适当的技术和组织措施，保障您的个人资料免遭未授权的访问、处理、删除或丢失。',
		titleInfo42: 'E. 查阅及改正资料',
		titleInfo43: '本部分内容与上文 PICS 中所列相同。',
		titleInfo44: 'F. Cookies 的使用',
		titleInfo45: '我们可能会使用 Cookies 或类似技术来提升用户体验及分析网站流量。您可通过浏览器设置禁用 Cookies，但这可能影响某些功能的正常使用。',
		titleInfo46: '更新日期：[2025/8/8]',
		titleInfo47: '联系方式：[s@rwa.ltd]',
	},
	footerAgreement: {
		title: '平台使用协议',
		titleTime: '最后更新：2025年8月28日',
		titleInfo1: '如果您未完全理解并接受以下内容，您不应购买、持有、消费或转移平台流通代币。',
		titleInfo2: '本平台使用协议中的所有内容（以下简称“本协议”）构成您与RWA Group（以下简称“我们”）之间的具有法律约束力的协议。RWA Group包括 RWAGroup Limited（一家在香港注册成立的有限公司；商业登记号码为74645397）、其任何关联主体、前述主体的所有雇员、外部服务承包商以及外部顾问。本协议适用于您与我们之间的相关法律关系，包括但不限于您在',
		titleInfo3: '平台RWA.LTD、网站【https://rwa.ltd】以及其他关联计算机端或手机端应用程序',
		titleInfo4: '（以下合称“平台”）购买、持有、消费或转移的在平台上流通的任何代币（以下简称“平台流通代币”）而产生的法律关系。访问或使用平台、注册平台账户、购买、持有、消费或转移平台流通代币、或从事其他与平台相关或基于平台的活动（以下合称“平台活动”或“活动”），您承认并同意您将遵守本协议。如果您就任何平台流通代币进行平台活动，您承认并同意您将遵守专门为该代币所代表的商品或服务所制定的协议，该协议可能以多种形式展现在平台，包括但不限于代币白皮书（以下简称“产品协议”）。您进一步承认并同意，基于商业合理性，我们能够单方面地、不时地且没有特别事先通知的情况下更新或修改所有上述协议，并且您应该在进行任何平台活动前，阅读并理解这些协议的最新版本以及其中引用的任何补充文件。',
		titleInfo5: '风险提示和同意',
		titleInfo6: '未免疑问，风险提示部分属于本协议不可分割的一部分，与其他部分具有同等法律效力。在做出任何与平台流通代币相关的决定或进行任何交易之前，您应采取一切合理措施确保已充分理解该交易，并独立评估其适当性和风险。在做出与平台流通代币相关的任何决定之前，您应确保您拥有充分的信息。如果您对平台流通代币、平台活动或本协议的任何内容有疑问，您应获得独立的专业意见。RWA Group已确定平台流通代币为香港《打击洗钱及恐怖分子资金筹集条例》（“AMLO”）第53ZR条定义的“有限用途数码代币”，即客户酬报或奖赏积分；游戏用资产；或任何符合以下说明的数码形式价值——(i)类似客户酬报或奖赏积分或游戏用资产；且(ii)按其发行人的用意，该数码形式价值不可转换为金钱或获得公众接受的另一交易媒介。因此，根据AMLO第53ZRA，平台流通代币不属于AMLO项下的“虚拟资产”，“VA”或“VirtualAsset”。平台流通代币并非作为证券或任何其他形式的投资产品进行结构化或销售。平台流通代币未经过任何监管机构审查、备案或授权。RWAGroup未进行、也不打算在任何相关法律禁止的司法管辖区进行与平台流通代币相关的任何活动。您应确保与平台流通代币相关的所有活动在适用司法管辖区内系合法的。',
		titleInfo7: '您在此承认您理解并承担多种风险（包括但不限于以下风险）及因这些风险而导致的所有损失：',
		titleInfo8: 'A. 与区块链技术和网络安全相关的风险',
		titleInfo9: '由于平台流通代币基于区块链技术，任何相关区块链的故障、崩溃或放弃可能会对平台流通代币产生重大不利影响。此外，密码学的进展或量子计算等技术进步可能会通过使基础区块链的密码学共识机制失效，从而对平台流通代币构成风险。与其他基于区块链技术的去中心化加密代币一样，平台流通代币容易受到节点或验证者的攻击，这些节点或验证者负责验证/确认平台流通代币在相关区块链上的交易。任何成功的攻击都可能对平台流通代币构成风险。黑客或其他恶意团体或组织可能会以多种方式干扰平台流通代币，包括但不限于恶意软件攻击、拒绝服务攻击、共识攻击、Sybil攻击、变相攻击和欺骗攻击。',
		titleInfo10: 'B. 与平台流通代币流动性不足相关的风险',
		titleInfo11: '平台流通代币没有业已存在的市场，平台流通代币的销售可能不会导致一个活跃或流动的市场。持有者可能面临平台流通代币的流动性风险。RWA Group不负责平台流通代币在任何市场上的流通和交易。无任何主体有义务从任何平台流通代币持有者处购买平台流通代币，也冇任何主体保证平台流通代币的流动性或市场价格。RWAGroup因此不得确保平台流通代币会有任何需求或市场。RWAGroup拥有出于各类考虑（例如法律、政策或执法变化等）而调整、限制或暂停平台流通代币的流动性和任何其他活动的权利，且不就此类调整、限制和暂停承担任何责任。',
		titleInfo12: 'C. 与价格波动相关的风险',
		titleInfo13: '平台流通代币的价格通常可能会因特定底层资产市场（例如相关知识产权、产品或服务等）等外部因素而相对波动，且在短期内可能会有较大波动。单一代表性区块链资产价格的下降可能会导致对区块链行业的信心不足，即使该资产与平台流通代币无关，其价格下跌亦可能导致整个区块链行业信心受挫，从而影响平台流通代币的市场。平台流通代币交易的实时价格面临实质性风险，并可能因市场条件和其他超出RWA Group控制的因素而大幅波动。',
		titleInfo14: 'D. 与不确定的监管限制相关的风险',
		titleInfo15: '除平台官方特别说明，平台流通代币未在香港AMLO项下的任何持牌虚拟资产交易平台上市，也不能保证将来会在前述平台上市交易。重要的是，尽管平台流通代币被设计和构建为“有限用途数字代币”或无任何投资属性的用益代币，而绝不作为《AMLO》第53ZRA条定义的“虚拟资产”或证券或其他投资产品，但是由于法律规则、执法态度或环境的变化，或由于RWA Group无法控制的其他原因，RWA Group有全权酌情调整、限制或暂停与平台流通代币相关的任何活动，对此RWA Group不承担任何赔偿责任。 如果您打算就平台流通代币采取任何（直接或间接）行动，您将负责遵守所有适用法律、法规和规则，并提供所有适当的风险提示和披露。',
		titleInfo16: 'E. 不可预见的风险',
		titleInfo17: '像平台流通代币这样的加密代币是一项新型且未经测试的技术。除上述风险外，购买、持有、消费、转移及其他平台流通代币活动可能会涉及RWA Group无法预见或合理控制的其他风险。这些风险可能会以不可预见的方式或组合形式显现。',
		titleInfo18: 'F. 平台政策变化的风险',
		titleInfo19: 'RWA Group基于（i）其认为的合法商业考虑、（ii）对现行法律和政策的理解或（iii）对法律和政策趋势的理解，保留随时更改平台流通代币、平台活动、本协议和任何产品协议的性质和内容（包括但不限于其供应和分配计划、政策和机制等）的权利。在做出任何与平台流通代币相关的决定之前，您应确保已仔细阅读并完全理解彼时平台上最新版本的本协议和已更新的其他相关内容。',
		titleInfo20: '1. 账户。',
		titleInfo21: '1.1注册。',
		titleInfo22: '您需要在平台注册账户，以确保您根据本协议享有的任何权利。然而，未注册或登录账户不会影响本协议作为有效协议在适用法律下对您和我们具有约束力。开设账户即表示您同意仅为自己使用该账户，任何第三方使用您的账户需要获得我们的书面同意。您对账户进行的所有活动及由此产生的法律后果承担全部责任。',
		titleInfo23: '1.2 限制措施。',
		titleInfo24: '平台有权在下列情形中，单方面采取账户冻结、交易限制和/或资产锁定等限制措施，无需事先通知用户：',
		titleInfo25: 'a. 接到司法机关、监管机构或有管辖权的其他机构的指示;',
		titleInfo26: 'b. 发现或合理怀疑账户存在异常交易、涉嫌洗钱、诈骗、非法集资、操纵市场、网络攻击或其他违法行为；',
		titleInfo27: 'c. 发现或合理怀疑账户违反本协议或平台其他规则；或',
		titleInfo28: 'd. 平台合理认为，为保障其他用户、平台或公共利益有必要对某些账户采取的任何限制措施。',
		titleInfo29: '平台采取冻结措施后，用户可按照平台要求提交相关资料申请解除冻结。平台有权根据自身判断决定是否解除冻结，并保留最终决定权。',
		titleInfo30: '1.3 用户自愿注销。',
		titleInfo31: '用户可透过平台提供的流程申请注销其账户。注销账户须符合以下条件：',
		titleInfo32: 'a. 账户内无未了结的交易或纠纷；',
		titleInfo33: 'b. 账户内无剩余资产；',
		titleInfo34: 'c. 未处于司法调查、监管审查或平台风控限制状态',
		titleInfo35: '账户一旦注销，将无法恢复；相关数据将依据适用法律法规及平台隐私政策予以处理。',
		titleInfo36: '1.4平台终止账户。',
		titleInfo37: '若平台合理判断存在下列情形之一，平台有权单方面终止账户并回收使用权，无须取得用户同意：',
		titleInfo38: 'a. 账户违反本协议或相关法律，或存在重大合规风险；',
		titleInfo39: 'b. 账户连续三年内未进行任何平台活动，平台视为用户已放弃账户；',
		titleInfo40: 'c. 账户身份信息虚假、冒名顶替、重复注册等；',
		titleInfo41: 'd. 账户从事任何损害平台利益、声誉或安全的行为；',
		titleInfo42: 'e. 其他平台认定需回收账户的合理事由。',
		titleInfo43: '平台终止账户后，视情况决定是否退还账户内剩余合法资产，若账户存在违法行为或损害平台利益的其他行为，平台有权抵扣相关损失后再行退还。',
		titleInfo44: '2. 信息和通信',
		titleInfo45: '2.1 身份验证。',
		titleInfo46: '您需在开设账户之前遵循我们的身份验证程序，通过向我们提供有关您的某些信息，以及在相关情况下提供任何被许可的第三方用户的信息。您提供的所有信息必须完整、准确且真实。若信息发生变更，您必须更新该信息。',
		titleInfo47: '您授权我们直接或通过第三方进行我们认为必要的查询，以验证您的身份及任何被许可的第三方用户的身份，以保护您和/或我们免受欺诈、洗钱、恐怖主义融资或其他犯罪行为的风险，并根据查询结果采取我们认为必要的措施。',
		titleInfo48: '当我们进行查询时，您承认并同意，您的个人信息以及任何被许可的第三方用户的信息可能会被披露给身份验证、合规性数据记录、信用参考、欺诈防范或金融犯罪机构，这些机构可能会对我们的查询作出完整回应。',
		titleInfo49: '2.2 强化尽职调查。',
		titleInfo50: '我们可能要求您通过提交有关您、您的业务或任何被许可的第三方用户的附加信息、提供额外记录或文档，或与RWA Group的授权代表进行面对面会议来遵循我们的强化尽职调查程序。',
		titleInfo51: '2.3 信息请求',
		titleInfo52: '为了遵守任何适用法律、身份验证要求、检测洗钱、恐怖主义融资、欺诈或任何其他犯罪，或其他有效理由，我们可能随时要求您提供信息。您同意提供我们要求的相关信息，并授权我们保留这些信息记录最长六（6）年。',
		titleInfo53: '2.4 通过注册电子邮件的通信。',
		titleInfo54: '您承认有义务检查您的电子邮件，包括垃圾邮件。RWA Group单方面发送的信息自发送后即视为有效传达至您。自发送后的七（7）个工作日内未作回应或采取行动将视为您无异议并同意RWA Group在该电子邮件中所表述的内容。',
		titleInfo55: '我们可以通过电子邮件向您的注册邮箱发出具有法律效力或后果的通知或其他通知。您有责任确保电子邮件地址是最新和准确的。通知一经发送至您提供的电子邮件地址，即视为已送达。若因您未及时更新电子邮件地址或未及时查阅邮件导致任何法律后果，由您独自承担。您仅能按照我们不时指示的方式向我们发送通知。',
		titleInfo56: '2.5 公告。',
		titleInfo57: '所有官方公告，包括但不限于促销、竞赛和空投等公告，将列出在平台上。这些公告很重要，可能与您对平台流通代币的活动决策有关。您有责任定期访问平台查阅相关公告，无论这些公告在您相应行为前或后发出。因未及时查阅公告导致的任何法律后果，由您独自承担。',
		titleInfo58: '2.6 录制。',
		titleInfo59: '您同意我们可以录制与您之间通过任何形式（包括但不限于电子通信、电话或面对面交流）进行的通信，并确认这些录音可作为双方通信的有效证据。您同意电话通话可能会在没有使用提示音或其他进一步通知的情况下进行录制。',
		titleInfo60: '3.  禁止活动。如用户或被平台合理怀疑进行以下禁止活动，平台有权立即采取包括但不限于限制交易、冻结账户、终止账户、回收代币及终止服务等措施，并保留依法追究责任的权利。在不影响本协议中任何其他限制或约束的情况下，您同意您和任何第三方用户不会：',
		titleInfo61: 'a. 违反本协议或根据本协议及相关本协议（包括但不限于任何产品协议）达成的任何协议；',
		titleInfo62: 'b. 从事任何以投资为目的的平台流通代币活动，将平台流通代币视为任何投资产品；以任何有意或客观上使平台流通代币被视为投资产品的方式行事；或从事任何活动增大平台流通代币被任何司法管辖区监管机构视为投资产品的风险；',
		titleInfo63: 'c. 对第三人或公开作出关于我们的任何虚假的',
		titleInfo64: '不利、批评或贬损',
		titleInfo65: '的言论、指控或评论（无论是明示还是暗示），除非该言论基于客观事实并已获得有效判决或裁定支持；',
		titleInfo66: 'd. 以违反公共利益、公共道德或他人合法利益的方式在平台上从事活动；',
		titleInfo67: 'e. 从事市场操纵行为（如拉高出货、对倒交易、自买自卖、前置交易、报价填充、欺骗或分层操作等），无论是否被适用法律禁止；',
		titleInfo68: 'f. 从事欺诈活动，或使我们怀疑您或任何许可用户从事欺诈活动和/或交易；',
		titleInfo69: 'g. 使用平台流通代币进行或参与非由我们举办监督的彩票、赌博活动、拍卖费用竞标、体育预测或赔率制定、现金奖品的虚拟体育联赛、网络游戏、竞赛、抽奖或任何机会游戏；',
		titleInfo70: 'h. 提供虚假、不准确或误导性的信息，这些信息与您在平台流通代币上的活动、与我们的通信或与本协议相关的其他事项相关；',
		titleInfo71: 'i. 修改或适应平台的全部或任何部分，或将平台合并或整合到其他程序或应用中；',
		titleInfo72: 'j. 修改、复制、重复、下载、存储、传输、传播、转让、拆解、广播、发布、删除或更改任何版权声明或标签，或许可、转许可、销售、镜像、设计、租赁、出售、私有化、授予该知识产权的担保权益或知识产权的任何部分，或创作衍生作品，或以任何方式利用任何部分的知识产权牟利；',
		titleInfo73: 'k. 违反或试图违反（i）任何适用的法律，（ii）我们或任何第三方的版权、专利、商标、商业秘密或其他知识产权，或（iii）公众权益或隐私权。',
		titleInfo74: '4. 实质利益和利益冲突',
		titleInfo75: '4.1 实质利益。',
		titleInfo76: '您理解并同意，RWA Group无义务向您披露或使用任何其知悉的信息为您谋取利益，且不对因未披露或使用而产生的任何后果承担责任。',
		titleInfo77: '您进一步确认，我们可能不时收到任何关于平台流通代币或平台活动的信息，这些信息可能会影响代币的价格或流通性。我们可能将前述信息合法用于我们自身的活动或利益。',
		titleInfo78: '4.2 RWA Group的活动。',
		titleInfo79: 'RWA Group或被其授权的任何员工可能会从事与平台流通代币相关的活动，尽管这些活动基于合法目的（包括但不限于提供代币流动性、防止第三方恶意操纵市场等），您理解并同意这些活动与您构成可能的利益冲突。',
		titleInfo80: '4.3 流动性提供者',
		titleInfo81: '您承认、同意并接受：',
		titleInfo82: 'a. 我们可能会任命一个或多个流动性提供者（其中可能包括RWA Group本身）来监控和调整平台流通代币市场，并且任何此类流动性提供者可能会与您作为交易对手方进行任何交易；',
		titleInfo83: 'b. 流动性提供者还可能在其流动性提供活动中持有多种虚拟资产（包括平台流通代币等）的头寸，包括与您头寸相反的虚拟资产头寸；',
		titleInfo84: 'c. 此类流动性提供活动可能通过算法交易进行。此类流动性提供可能会对平台流通代币的价格和执行交易所需的流动性产生影响；',
		titleInfo85: 'd. 流动性提供系基于合法目的（例如维持平台市场稳定、防止第三方恶意操纵市场等），您不得因流动性提供行为对我们或与相关人员提出提出任何法律索赔、损害赔偿或禁令申请；',
		titleInfo86: 'e. 我们在进行流动性提供时可能会实现利润，也可能面临损失，此类利润或损失不构成对用户的任何义务或责任。',
		titleInfo87: '5. 平台流通代币的购买和消费',
		titleInfo88: '平台展示的关于平台',
		titleInfo89: '流通代币、商品或服务',
		titleInfo90: '的性质、品质和价格等信息仅为展示作用，不属于邀约，至多为具体产品协议中标明的销售商或代币发行方发出的要约邀请。',
		titleInfo91: '当您在平台购买或者消费平台流通代币以兑换商品或服务时，请您务必仔细确认所兑换商品或服务的品名、价格、数量、型号、规格以及尺寸，或权利的范围、内容以及时间，或对兑换方的限制性要求等重要事项，并在兑换下单时核实您的账户名称、电子邮箱以及收货地址等信息。如您填写的收货信息并非您本人，收货人的行为和意思表示视为您的行为和意思表示，您应对收货人的行为及意思表示的法律后果承担连带责任。',
		titleInfo92: '您的消费行为应当基于真实的消费需求，不得存在对商品或服务实施恶意购买、恶意维权、恶意炒作等扰乱平台正常交易秩序的行为。为维护平台交易秩序及安全，RWA Group有权在发现上述情形时采取包括但不限于关闭订单、限制账户、冻结资产等措施。',
		titleInfo93: '除非有明确的相反明示，当您在平台购买、交易、消费平台流通代币以兑换实体商品或服务或进行其他平台活动时，仅涉及您与销售商或代币发行方之间的法律关系，RWA Group不得以任何方式被认定为该法律关系的参与方。我们亦不对相关平台流通代币、代币表征权益（商品、服务或其他非金融性权益）作出任何明示或暗示的陈述或保证，包括但不限于代币的成功兑现、相应商品或服务的适销性或特定用途的适用性。',
		titleInfo94: '您同意在任何情况下，不对RWA Group基于代币消费行为等平台活动提出任何意义的法律指控、损害赔偿或禁令等。',
		titleInfo95: '6. 技术免责声明',
		titleInfo96: '6.1 无任何陈述或担保。',
		titleInfo97: '我们通过平台提供的任何信息以及您与我们之间的通信，均以“现状”和“可用”基础提供，不作为任何准确性、完整性或时效性的陈述或担保，无论是明示或暗示的，前述声明在适用法律允许的最大范围内有效。',
		titleInfo98: '具体来说，我们明确否认所有暗示担保，包括但不限于所有权、适销性、特定用途适用性和/或不侵犯他人权利的担保。我们不保证您访问或使用平台及相关通信的持续性、稳定性或及时性，以及前述活动中涉及的任何材料内容的完整性、无误性作出任何陈述或担保。这可能导致您在一定时间内无法进行平台流通代币相关活动，并可能导致相关交易时间延迟。',
		titleInfo99: '6.2 暂停访问。我们可能会不时暂停您对平台的访问或使用，以进行定期或紧急的安全维护。',
		titleInfo100: '7. 本协议及平台的变更。我们可以在全权自行决定的情况下，随时修改本协议以及平台的任何内容，包括平台流通代币本协议以及相关活动的功能和内容。',
		titleInfo101: '您注册平台账户或继续访问、使用平台，或购买、持有、消费或转让平台流通代币，即视为您已充分阅读、理解并同意接受更新后的本协议。',
		titleInfo102: '如果您不希望接受任何变更，您应立即停止持有平台流通代币并停止进行任何平台活动，并通过联系RWA Group的相关人员注销您的账户。',
		titleInfo103: '8. 合规合作。您同意配合RWA Group出于合规考虑就平台流通代币或平台活动进行任何调查和调整。如有任何监管机构就平台流通代币或相关活动联系您，您同意在适用法律允许的范围内立即通知RWA Group，并提供所有相关信息。',
		titleInfo104: '9. 声明和保证。您在此向我们声明和保证，始终遵守以下事项：',
		titleInfo105: 'a. 您已经透过自身学习或咨询专业法律人员或咨询人员后，充分了解平台业务以及平台流通代币的本质和任何风险;',
		titleInfo106: 'b. 您提供给我们的所有档和信息在各方面均为真实、准确、完整并且最新的，我们在所有情况下可以依赖这些信息；',
		titleInfo107: 'c. 与本协议相关的所有决定完全和专门基于您自身的判断，并在您独立评估了您的财务资源、能力、愿意承担的相关风险和财务目标后做出；',
		titleInfo108: 'd. 您具备完全的权力、授权和能力：',
		titleInfo109: 'a) 访问和使用平台；',
		titleInfo110: 'b) 从事平台流通代币上的任何活动；',
		titleInfo111: 'c. 您已获得所有必要的第三方同意、许可、授权、批准和协议，以及所有必需的、或希望获得的政府监管机构、政府部门、委员会、代理机构或其他具有管辖权的组织的批准、同意、许可、注册、声明和报备，以便：',
		titleInfo112: 'a) 访问和使用平台；',
		titleInfo113: 'b) 从事平台流通代币上的任何活动；',
		titleInfo114: '10. 我们职责的性质。',
		titleInfo115: '您理解并同意，您与RWA Group之间的关系，或任何其他事项（包括但不限于您将资金存入平台账户中），不构成任何信托、受托、代理或合伙关系，我们不对您承担任何受托人义务。RWA Group有权因外部或内部商业原因，合理调整任何平台流通代币、产品或服务的价格及相关参数，而无需事先通知您。',
		titleInfo116: '我们亦不提供任何投资、法律、税务、会计或财务建议，且不对平台服务、平台流通代币以及平台活动的市场表现以及监管批准作出保证，您应自行在相应司法管辖区履行判断、决策及合规义务，并确认理解并接受使用平台以及交易平台流通代币产生的相关风险。',
		titleInfo117: '除非特别明示说明，我们不得被以任何方式认定为平台流通代币的发行方和/或表征权益的销售商，我们仅为平台流通代币的发行方和/或表征权益的销售商和用户建立了沟通渠道。',
		titleInfo118: '11. 补偿。',
		titleInfo119: '您在此承诺并同意，在任何第三方、政府机关或行业组织向我们提出索赔、诉讼、行动、要求、争议、指控或调查时，全额补偿我们并使我们免于承担任何索赔、责任、损害赔偿（包括实际和间接损害赔偿）、损失（包括任何直接或间接的金钱损失、名誉损失等）、成本和费用，包括但不限于所有利息、罚款以及法律和其他合理的律师费和其他专业费用（“赔偿损失”），这些索赔或损失因以下任何事项产生或以任何方式与之相关：',
		titleInfo120: 'a. 您访问或使用平台或在平台流通代币上的任何活动；',
		titleInfo121: 'b. 您违反或涉嫌违反本协议或其他相关协议，包括任何产品协议；',
		titleInfo122: 'c. 您违反任何适用的法律；',
		titleInfo123: 'd. 您侵犯任何第三方的权利。',
		titleInfo124: '12. 责任',
		titleInfo125: '12.1 我们的责任。',
		titleInfo126: '在适用法律允许的最大范围内，RWA Group对您或任何第三方因平台活动或平台流通代币遭受的任何直接和间接损失不承担任何责任。 在不影响前述规定的前提下，在任何情况下，RWA Group的责任总额不超过您在导致损失的事件发生之前的十二（12）个月内支付给RWA Group的费用金额。该金额将由我们支付给您，作为我们对所有损失和索赔的全部和最终赔偿，并且足以解除我们对此类损失和索赔的全部责任。您承认并同意，RWA Group不了解与您相关的任何特殊情况，且前述金钱赔偿为您唯一且充分的补救措施，您无权或放弃根据法律或衡平法要求任何其他索赔或救济，包括但不限于任何损害赔偿、物权主张、禁令和/或特定履行。',
		titleInfo127: '12.2 责任限制。',
		titleInfo128: '尽管本协议中的其他条款可能有不同规定，您在此承认并同意，在任何情况下，我们对您或任何其他个人或实体不承担以下责任：',
		titleInfo129: 'a. 任何直接或间接的损失（包括金钱损失、商业机会损失等），无论系因以下事项引起的，还是与平台流通代币的其他任何事项相关：',
		titleInfo130: 'a) 任何风险警告中标明的风险（风险警告会不时更新）；',
		titleInfo131: 'b) 平台流通代币或平台活动中涉及的其他虚拟资产底层协议的操作、功能、安全性或可用性',
		titleInfo132: 'c) 根据本协议的任何行动或不作为；',
		titleInfo133: 'd) 任何数据形式中的不准确性、缺陷或遗漏，任何此类数据的传输错误或延迟，以及任何此类数据的中断；',
		titleInfo134: 'e) 我们进行的定期或不定期维护，包括由此产生的服务中断和更改；',
		titleInfo135: 'f) 其他用户的行为、不作为或违反本协议，以及任何其他第三方的行为所造成的损害；',
		titleInfo136: 'g) 平台活动的任何终止、暂停、冻结或限制访问；',
		titleInfo137: 'h) 我们无法通过您提供的联系方式与您联系；',
		titleInfo138: 'i) 我们拒绝或延迟执行任何指令；',
		titleInfo139: 'j) 您因第三方行为而遭受的损失，包括涉及RWA Group或平台流通代币的第三方诈骗;',
		titleInfo140: 'k) 任何区块链网络事件、分叉（Fork）或空投（Airdrop）；',
		titleInfo141: 'l) 由平台或我们提供的产品或服务的正确性、质量、准确性、安全性、完整性、可靠性、性能、及时性、定价或持续可用性；由平台或我们提供的任何内容的延迟、遗漏或错误；',
		titleInfo142: 'm) 您在平台上进行的任何交易、指令或操作。',
		titleInfo143: 'b. 任何特殊的、惩罚性的、加重的、偶然的、间接的或后果性的损失或损害，无论系因我们的平台、平台流通代币、本协议、产品协议，和/或根据本协议或与本协议相关的任何协议而产生的，或与之相关的；',
		titleInfo144: 'c. 您可能因明显错误（Manifest Error）和/或极端市场（包括但不限于任何地域的虚拟资产市场、特定产品市场和金融市场）波动和/或任何交易的取消/修改而遭受的任何损失或损害，无论系直接仲系间接的、特殊的仲系后果性的，包括但不限于金钱损失和机会损失；和/或',
		titleInfo145: 'd. 您未通过正式法律行动在与索赔事项相关的事项发生之日起一年内提起的任何索赔。',
		titleInfo146: '12.3 沟通前置。',
		titleInfo147: '您同意在与我们产生任何纠纷时，在接触任何监管机关或司法机关前，首先联系我们以沟通关于纠纷的所有情况，您同意不会将任何纠纷相关的信息向第三方披露。',
		titleInfo148: '13. 适用法律和争议解决。',
		titleInfo149: '本协议应受香港特别行政区法律的管辖，并按其解释。您同意将所有此类争议或索赔提交至香港特别行政区法院的专属管辖并放弃对法院管辖权的任何异议。',
		titleInfo150: '如果RWA Group对您提起诉讼，RWA Group将通过您提供的电子邮件地址通知您。您同意，任何发送到该电子邮件地址或邮寄地址的通知都应视为有效，无论是否涉及服务的充分性。您有责任确保注册账户时提供的电子邮件地址是最新和准确的。',
		titleInfo151: '双方同意，所有与诉讼相关的信息应保持机密。尽管如此，一方可以在以下情况下披露此类机密信息：',
		titleInfo152: 'a. 如果获得另一方书面同意；',
		titleInfo153: 'b. 在适用法律或任何有管辖权的监管或监督机构的规定要求下，或根据法院或其他有管辖权的权威机构的命令；',
		titleInfo154: 'c. 如果相关的机密信息已不再是机密信息，而是通过违反本协议以外的方式进入公共领域。',
		titleInfo155: '14. 集体诉讼放弃。',
		titleInfo156: '您和RWA Group同意，任何索赔应仅以个人名义提出，而非作为集体诉讼或代表诉讼中的原告或集体成员。您进一步同意放弃根据适用法律的允许范围内，将此类索赔作为集体、集合、代表或私人检察官诉讼的权利。未经 RWA Group同意，个人索赔不得合并或合并成单一诉讼。此放弃在适用法律允许的最大范围内适用。',
		titleInfo157: '15. 协议终止。',
		titleInfo158: '本协议自您首次访问平台时起即对您具有法律约束力，并持续有效，直至您仅按照本协议所载明的账户注销程序，正式注销您的账户，方可终止本协议。若在协议终止后，您再次访问平台，协议将再次对您生效。协议终止后，本协议中非涉及平台使用的条款继续有效，这类条款包括但不限于本协议第8条至第14条（包括第8条和第14条本身）。',
		titleInfo159: '16. 其他',
		titleInfo160: '16.1完整协议。',
		titleInfo161: '本协议以及任何产品协议构成您与我们之间的完整协议。您确认，除非本协议或任何产品协议中明确规定，否则不会依赖于任何陈述、声明、保证或担保（无论是疏忽还是无意）。',
		titleInfo162: '16.2 转让。',
		titleInfo163: '在未获得我们事先书面同意的情况下，您不得转让或转移您在本协议下的任何权利或义务。任何未经授权的转让或转移均属无效，并不产生对RWA Group的约束力。然而，我们可能不时将本协议下的任何权利或义务转让或转移给任何其他方，包括但不限于与RWA Group任一主体的合并、收购或其他公司重组相关的情况。',
		titleInfo164: '16.3 无效性。',
		titleInfo165: '本协议的每一部分在判断其合法性、有效性或可执行性时，应可与本协议中的其他部分分开。如果本协议的任何部分在任何时候变得非法、无效或无法执行，则其余部分的合法性、有效性或可执行性不会因此受到影响或损害。',
		titleInfo166: '16.4 语言。',
		titleInfo167: '为便于閲读，可能会提供本协议的翻译版本，翻译版本可能采用除英语以外的其他语言。然而，英语版本的本协议为正式版本，您应确保完全理解英语版本；因未理解而导致的风险或损失由您自行承担。',
		titleInfo168: '16.5 存续。',
		titleInfo169: '尽管您在平台上的活动可能已被暂停或终止，但本协议以及任何适用的产品协议仍会在您根据本协议或任何适用产品协议需要履行义务或责任时继续适用于您。',
		titleInfo170: '16.6 不放弃。',
		titleInfo171: '我们在行使本协议下的任何权利或救济时的任何延迟或遗漏，不应视为放弃未来行使该权利或救济，或放弃本协议下的任何其他权利或救济。本协议中提供的权利和救济是累积性的，不排除适用法律提供的任何权利或救济。除非以书面形式作出并经RWA Group签署，否则任何放弃均不视为有效。',
		titleInfo172: '16.7 税务。',
		titleInfo173: '确定您所支付或收到的款项是否适用税收以及收取、报告和上缴正确税款的责任在于您。您同意，我们不负责确定您的平台流通代币活动是否适用任何税收，也不负责收取、报告或上缴任何由此产生的税款。您应独立向相关税务机关申报并缴纳因平台活动产生的税款，我们不承担任何连带责任。',
		titleInfo174: '16.8 隐私。',
		titleInfo175: '我们致力于确保通过平台提交的所有个人数据严格遵守《个人资料(私隐)条例》（PDPO）的相关规定。由于不同的目的，您可能不时被邀请通过平台或其他方式向RWA Group提供个人数据。个人信息可能包括姓名、电话号码、邮寄地址或电子邮件地址。RWA Group会在邀请您提供此类信息时明确帮助收集目的和用途。除非法律允许或要求，否则RWA Group不会在未获得您事先同意的情况下将您的个人数据披露给任何第三方。',
	},
	...zhLocale
}
export default zh;
